import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { GatewayService } from 'src/app/services/gateway/gateway.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { PanelIOTService } from 'src/app/services/panel-iot/panel-iot.service';
import { SensorService } from 'src/app/services/sensor/sensor.service';
import { ZoneService } from 'src/app/services/zone/zone.service';
import { ShiftService } from 'src/app/services/shift/shift.service';
import { PanelSensorModalComponent } from 'src/app/shared/components/modals/panel-sensor-modal/panel-sensor-modal.component';
import { SensorModalComponent } from 'src/app/shared/components/modals/sensor/sensor-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { environment } from 'src/environments/environment';
import 'fabric';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
declare const fabric: any;
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Router } from '@angular/router';
import { ActuatorDetailPanelModalComponent } from 'src/app/shared/components/modals/actuator-detail-panel-modal/actuator-detail-panel-modal.component';
import { ActuatorService } from 'src/app/services/actuator/actuator.service';
import * as signalR from '@microsoft/signalr';
import { PanelIotActionModalComponent } from 'src/app/shared/components/modals/panel-iot-action-modal/panel-iot-action-modal.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { trigger, transition, style, animate } from '@angular/animations';
import { PlanAccionPanelIotFormComponent } from './plan-accion-panel-iot/plan-accion-panel-iot-form/plan-accion-panel-iot-form.component';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-panel-iot',
  templateUrl: './panel-iot.component.html',
  styleUrls: ['./panel-iot.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
      ])
    ])
  ]
})

export class PanelIotComponent implements OnInit {
  @ViewChild('excelTable', { static: false }) excelTable: ElementRef;

  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['enterprise','headquarter','gateway','name','description','nomenclature','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isAdminGys: boolean = false;
  countMaxUserByEnterprise: number = 0;
  enterprises = [];
  headquarters = [];
  gateways = [];
  subscription: Subscription;
  enterpriseSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  showTypeSelect = "3";
  headquarterSelect: number = 0;
  gatewaySelect: number = 0;
  zones = [];
  isPoza = false;
  zoneSelect: number =0;
  canvas: any;
  nameMarker: string = '';
  sensors = [];
  paneliotSearch = [];
  selectedPanelIOT = 0;
  selectedNomenclature: string = "0";
  checkedGrafica = false;
  checkedTabla = false;
  checkedMapa = false;
  showSensorEdit = false;
  showGraphSensor = false;
  showSensorsGraphs = false;
  showLavelSensorsTable:boolean = false;
  displayListStadistics = 'none';
  dataStreaming = [];
  dataStreamingColumn = [];
  dataStreamingColumnSensorsInit = [];
  dataStreamingColumnSensors = [];
  dataStreamingColumnActuators = [];
  colorToggle = "";
  imageZone = "";
  initPage = false;
  private _hubConnection: HubConnection;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  guardTotal = "";
  guardTotalTQ ="";
  contentTotal ="";
  isGuardTotal = false;
  enabledRead: number;
  enabledWrite: number;
  editSetting = false;
  isPhone = false;
  loadData = false;
  isTank = false;
  isTelar = false;
  maxCapacityPoza = "";
  nowCapacityPoza = "";
  enabledCapacityPoza = "";
  percentageMaxCapacityPoza = 0;
  percentageNowCapacityPoza = 0;
  percentageEnabledCapacityPoza = 0;
  selectSensorMenu = 0;
  dropdownSettings:IDropdownSettings;
  filterIOT = [];
  qtyEnabled = 0;
  qtyDisabled = 0;
  sensorTypesCountEnabled = [];
  sensorValuesVisibles = [];
  showGraphSensorPanel = false;
  sensorTypesCountDisabled = [];
  sensorTypesCountEnabledObj= new Map<String, String>();
  sensorTypesCountDisabledObj= new Map<String, String>();
  test = new EventEmitter<number>();
  showAllHeadquarters = true;
  showLegend: boolean = false;
  showSensors = true;
  showActionRegister = true;
  selectedSensor: any;
  selectedType: string;
  lastRefresh: string = ''; 
  groupingType: string = 'actuator';
  
  // Propiedades para registros de producción
  showAddRegistroForm: boolean = false;
  registrosProduccion: any[] = [];
  newRegistro: any = {
    telar: '',
    fechaInicio: '',
    fechaFin: '',
    distancia: null
  };
  groupedByActuator: any[] = [];
  groupedBySensor: any[] = [];
  groupedByType: any[] = [];
  shiftSelect: number = 0;
  dateSelect: Date = new Date(); // Fecha seleccionada como objeto Date
  shifts: any[] = []; // Lista de turnos obtenida del servicio
  // Propiedades para análisis de vibración
  vibrationSummary: any = null;
  
  // Propiedades para análisis OEE
  oeeSummary: any = null;
  oeeSummaryCache: any = null; // Cache para evitar múltiples llamadas en el template
  
  // Propiedad para forzar actualización de vistas
  filterUpdateTrigger: number = 0;
  
  // Propiedades para turnos
  currentShift: string = '0'; // 'day' o 'night'
  currentDate: string = '';
  shiftStartTime: string = '06:30';
  shiftEndTime: string = '18:30';
  
  // Propiedad para el dashboard view
  currentDashboardView: string = 'telares';

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private changeDetector: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private actuatorService: ActuatorService,
    private headquarterService: HeadquarterService,
    private gatewayService: GatewayService,
    private panelIOTService: PanelIOTService,
    private zoneService: ZoneService,
    private shiftService: ShiftService
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'IOT > <span class="font-weight-bold">Panel de Actuadores y Sensores</span>';
      const userAgent: string = navigator.userAgent || navigator.vendor;
      const isMobileDevice = (): boolean => {
        const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
        return regexs.some((b) => userAgent.match(b))
      }
      this.isPhone = isMobileDevice();
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'sensor',
        tooltipField: 'Sensor',
        selectAllText: 'Todos',
        unSelectAllText: 'Limpiar',
        searchPlaceholderText: 'Buscar',
        noFilteredDataAvailablePlaceholderText: 'Item no encontrado',
        itemsShowLimit: 6,
        allowSearchFilter: true, //input search
      };

        var _this = this;
        const connection = new signalR.HubConnectionBuilder()
        .withUrl(environment.fnIOT + '/notification') //+ '/api')
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      
        if(_this.showTypeSelect == '1' || _this.showTypeSelect == '3'){
          connection.on('eventHubIOT', (message) => {
            console.log("message",message);
            if(!_this.isPhone){
              _this.removeActuatorsSensors();
              _this.removeLabelValueSensors();
            }
            if(!_this.loadData){
              _this.getList();
            }
          });

          connection.start()
            .catch(console.error);
        }else{
          connection.stop().catch(console.error);
        }

 /*
          setInterval(()=>{
           _this.dataStreaming.forEach(x =>{
              if(x.idActuatorType == 1){
                var value = (Math.random() * (0.93 - 0.90) + 0.90).toFixed(3);
                var data = {
                  id: x.idActuator,
                  density: value
                }
                _this.actuatorService.updateDensity(data).subscribe(_ =>{});
              }
            });
            _this.removeActuatorsSensors();
            _this.removeLabelValueSensors();
            if(_this.showTypeSelect == '1'){
              
            }
              
          },300000);*/

          setInterval(() => {
            _this.getList(); // tu función que refresca los datos

            const now = new Date();
            _this.lastRefresh = now.toLocaleString('es-PE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
            });

          }, 120000); // 2 minutos

      var enabledCapacityPoza = Math.floor(Math.random() * (6000 - 100 + 1)) + 100;
      this.maxCapacityPoza = "6000 TN";
      this.enabledCapacityPoza =  enabledCapacityPoza + " TN";
      this.nowCapacityPoza = (6000 - enabledCapacityPoza).toFixed(2) + " TN";
      this.percentageEnabledCapacityPoza = Math.round((enabledCapacityPoza*100)/6000);
      this.percentageNowCapacityPoza = 100 - this.percentageEnabledCapacityPoza;
   }

   offEdit(){
    this.editSetting = this.editSetting == true ? false : true;
    if(this.editSetting){
      this.showGraph();
    }
   }

   openPlanAction(sensor: any,type:string) {
    this.selectedSensor = sensor;
    this.selectedType = type;
    this.showSensors = false;
  }

  openctionRegister(sensor: any,type:string) {
    this.selectedSensor = sensor;
    this.selectedType = type;
    this.showSensors = false;
  }

   openPopup() {
    const dialogRef = this.dialog.open(PlanAccionPanelIotFormComponent, {
      width: '400px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
     
    });
  }

   setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    
    // Actualizar variables CSS dinámicas
    this.updateCSSVariables();
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  ngOnInit() {
    this.setLS();
    this.panelIOTService.setDataStreamingSensors([]);
    this.initializeShiftAndDate();
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getGuardTotalTQ();
    
    // Asegurar que las variables CSS se actualicen al cargar
    setTimeout(() => {
      this.updateCSSVariables();
    }, 100);
    this.getZones();
    this.getShifts();
   // this.getSensors();
    
    // Iniciar monitoreo de turnos
    this.startShiftMonitoring();
    
    var _this = this;
   /*setInterval(function () {
      if(_this.showSensorsTable){
        _this.dataStreaming = _this.panelIOTService.getDataStreamingSensors();
        _this.removeValueSensors();
        _this.createValueSensor();
      }
    }, 1000);*/
    const now = new Date();
    this.lastRefresh = now.toLocaleString('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  ngAfterViewInit(): void {
    //this.getCanvas();
  }

  exportAsExcel() {
    /* table id is passed over here */
    let element = document.getElementById('excelTableId');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    var date = new Date();
    var downfileNameload = `panel_sensores_actuadores-${date}.xls`;
    XLSX.writeFile(wb, downfileNameload);
}


exportGraph24Hours(d:any){
  /* table id is passed over here */
  var labels = d.labels;
  var data = d.data;
  var list = [];
  let objectDate = new Date();
  let day = objectDate.getDate();
  console.log(day); // 23

  let month = objectDate.getMonth() + 1;

  let year = objectDate.getFullYear();
  console.log(year); // 2022
  var dia = day.toString();
  if (day < 10) {
    dia = '0' + day.toString();
  }
  var mes = month.toString();
  if (month < 10) {
     mes = `0${month}`;
  }
  let fecha = `${dia}/${mes}/${year}`;
  var ayer = new Date(objectDate.getTime() - (24 * 60 * 60 * 1000));
  let day2 = ayer.getDate();
  console.log(day2); // 23

  let month2 = ayer.getMonth()+ 1;

  let year2 = ayer.getFullYear();
  console.log(year2); // 2022
  var dia2 = day2.toString();
  if (day2 < 10) {
    dia2 = '0' + day2.toString();
  }
  var mes = month.toString();
  if (month2 < 10) {
     mes = `0${month}`;
  }
  let fechaAyer = `${dia2}/${mes}/${year2}`;
  var ddd = fechaAyer;
  var first0 = false;
  var exist0 = labels.filter(x => x == 0);
  for(var i = 0; i<25;i++)
  {
    console.log(labels[i]+ "  &&   "+ !first0 + "  && "+exist0.length);
    if(labels[i]==0 && !first0 && exist0.length == 1){  ddd = fecha; first0 = true; }
    else if(labels[i]==0 && !first0 && i > 0 && exist0.length == 2){  ddd = fecha; first0 = true; }
    list.push({
      Fecha: ddd,
      Hora: labels[i],
      Valor: data[i]
    });
  }

  ///const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(list);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */
  var date = new Date();
  var downfileNameload = `reporte_grafica_sensores_actuadores-${date}.xls`;
  XLSX.writeFile(wb, downfileNameload);
}

  setTheme(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    
    // Actualizar variables CSS dinámicas
    this.updateCSSVariables();
  }

  updateCSSVariables() {
    const root = document.documentElement;
    if (this.color1) {
      root.style.setProperty('--dynamic-color1', this.color1);
    }
    if (this.color2) {
      root.style.setProperty('--dynamic-color2', this.color2);
    }
  }

  // Método para inicializar turno y fecha actual
  initializeShiftAndDate() {
    const now = new Date();
    
    // Obtener fecha actual en formato YYYY-MM-DD usando fecha local
    const year = now.getFullYear();
    const month = this.padZero(now.getMonth() + 1);
    const day = this.padZero(now.getDate());
    this.currentDate = `${year}-${month}-${day}`;
    this.dateSelect = new Date(); // Inicializar dateSelect con la fecha actual del sistema
    
    console.log('Fecha del sistema inicializada:', this.dateSelect);
    console.log('Fecha formateada para payload:', this.currentDate);
    
    // Determinar turno basado en la hora actual (solo para referencia, no para establecer automáticamente)
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour + (currentMinute / 60);
    
    // Establecer horarios por defecto
    this.shiftStartTime = '06:30';
    this.shiftEndTime = '18:30';
    
    console.log(`Turno por defecto: ${this.shiftSelect} (Todos), Fecha: ${this.currentDate}, Hora: ${currentTime}`);
  }

  // Método para actualizar solo el turno sin afectar la fecha
  updateShiftOnly() {
    const now = new Date();
    
    // Determinar turno basado en la hora actual (solo para referencia, no para establecer automáticamente)
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTime = currentHour + (currentMinute / 60);
    
    // Actualizar solo la información del turno, no la fecha
    if (currentTime >= 6.5 && currentTime < 18.5) {
      this.currentShift = 'day';
    } else {
      this.currentShift = 'night';
    }
    
    console.log(`Turno actualizado: ${this.currentShift}, Hora: ${currentTime}`);
  }

  // Método para establecer turno y sus horarios
  setShift(shift: any) {
    console.log('setShift llamado con:', shift);
    this.shiftSelect = shift;
    if (shift === 0) {
      // Todos los turnos
      this.shiftStartTime = '06:30';
      this.shiftEndTime = '18:30';
    } else if (shift === 1) {
      // Turno día
      this.shiftStartTime = '06:30';
      this.shiftEndTime = '18:30';
    } else {
      // Turno noche
      this.shiftStartTime = '18:30';
      this.shiftEndTime = '06:30';
    }
    console.log('shiftSelect actualizado a:', this.shiftSelect);
  }

  // Método para actualizar turno automáticamente
  startShiftMonitoring() {
    // Actualizar cada minuto para detectar cambios de turno
    setInterval(() => {
      const previousShift = this.currentShift;
      this.updateShiftOnly(); // Solo actualizar el turno, no la fecha
      
      // Si cambió el turno, actualizar los datos
      if (previousShift !== this.currentShift) {
        console.log(`Cambio de turno detectado: ${previousShift} -> ${this.currentShift}`);
        this.getList(); // Refrescar datos con el nuevo turno
      }
    }, 60000); // 60 segundos
  }

  // Método para obtener información del turno actual
  getCurrentShiftInfo(): any {
    return {
      shift: this.currentShift,
      shiftText: this.currentShift === 'day' ? 'Día' : 'Noche',
      date: this.currentDate,
      timeRange: `${this.shiftStartTime} - ${this.shiftEndTime}`,
      icon: this.currentShift === 'day' ? 'wb_sunny' : 'nights_stay'
    };
  }

  // Método para obtener el turno en formato numérico para el backend
  getCurrentShiftNumber(): number {
    return this.currentShift === 'day' ? 1 : 2;
  }

  // Método para cambiar turno manualmente
  changeShift(shift: any) {
    this.shiftSelect = shift.value;
    console.log('changeShift - shiftSelect:', this.shiftSelect, 'groupingType:', this.groupingType);
    console.log('changeShift - dateSelect preservada:', this.dateSelect);
    
    // Actualizar horarios según el turno seleccionado
    if (shift === 0) {
      // Todos los turnos - usar horarios por defecto
      this.shiftStartTime = '06:30';
      this.shiftEndTime = '18:30';
    } else if (shift === 1) {
      // Turno día
      this.shiftStartTime = '06:30';
      this.shiftEndTime = '18:30';
    } else if (shift === 2) {
      // Turno noche
      this.shiftStartTime = '18:30';
      this.shiftEndTime = '06:30';
    }
    
    // Limpiar cache OEE cuando cambie el filtro
    this.clearOEECache();
    
    // Si estamos en la pestaña de gráficos, refrescar datos y regenerar gráficos
    if (this.groupingType === 'type') {
      console.log('changeShift - Refrescando datos y regenerando gráficos porque estamos en pestaña type');
      // Los gráficos se regenerarán automáticamente cuando getList() termine
    }
    
    // Forzar actualización de vistas
    this.triggerViewUpdate();
    
    this.getList(); // Refrescar datos con el nuevo turno
  }

  // Método para cambiar fecha manualmente
  changeDate(event: any) {
    const selectedDate = event.value;
    if (selectedDate) {
      // Actualizar dateSelect con el objeto Date seleccionado
      this.dateSelect = selectedDate;
      
      console.log('changeDate - dateSelect:', this.dateSelect, 'groupingType:', this.groupingType);
      
      // Limpiar cache OEE cuando cambie el filtro
      this.clearOEECache();
      
      // Si estamos en la pestaña de gráficos, refrescar datos y regenerar gráficos
      if (this.groupingType === 'type') {
        console.log('changeDate - Refrescando datos y regenerando gráficos porque estamos en pestaña type');
        // Los gráficos se regenerarán automáticamente cuando getList() termine
      }
      
      // Forzar actualización de vistas
      this.triggerViewUpdate();
      
      this.getList(); // Refrescar datos con la nueva fecha
    }
  }

  // Método para alternar entre turnos
  toggleShift() {
    const newShift = this.currentShift === 'day' ? 'night' : 'day';
    this.changeShift(newShift);
  }

  // Método para verificar si un valor es "on"
  isOnValue(value: any): boolean {
    if (value === null || value === undefined) return false;
    const strValue = String(value).toLowerCase().trim();
    return strValue === 'on' || strValue === '1' || strValue === 'true' || strValue === 'encendido';
  }

  // Método para verificar si un valor es "off"
  isOffValue(value: any): boolean {
    if (value === null || value === undefined) return false;
    const strValue = String(value).toLowerCase().trim();
    return strValue === 'off' || strValue === '0' || strValue === 'false' || strValue === 'apagado';
  }

  // Método para formatear tiempo en segundos a formato legible
  formatTimeFromSeconds(seconds: number): string {
    if (!seconds || seconds < 0) return '0s';
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    
    let result = '';
    
    if (hours > 0) {
      result += `${hours}h `;
    }
    if (minutes > 0) {
      result += `${minutes}m `;
    }
    if (remainingSeconds > 0 || result === '') {
      result += `${remainingSeconds}s`;
    }
    
    return result.trim();
  }

  // Método para formatear el valor del sensor según su unidad
  formatSensorValue(value: any, unit: string): string {
    // Si el valor es null o undefined, mostrar 0
    if (value === null || value === undefined) {
      return `0 ${unit || ''}`.trim();
    }
    
    // Si la unidad es segundos (s, sec, seconds, segundos), formatear como tiempo
    const timeUnits = ['s', 'sec', 'seconds', 'segundos', 'seg'];
    const unitLower = unit ? unit.toLowerCase().trim() : '';
    
    if (timeUnits.indexOf(unitLower) !== -1) {
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue)) {
        return this.formatTimeFromSeconds(numericValue);
      }
    }
    
    // Si la unidad es metros o kilómetros, formatear con 2 decimales
    const distanceUnits = ['m', 'km', 'metros', 'kilometros', 'distance'];
    if (distanceUnits.indexOf(unitLower) !== -1) {
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue)) {
        return `${numericValue.toFixed(2)} ${unit || ''}`.trim();
      }
    }
    
    // Para otros valores, devolver tal como están
    return `${value} ${unit || ''}`.trim();
  }

  // Función para formatear fecha y hora
  formatDateTime(dateTimeString: string): string {
    if (!dateTimeString) return '';
    
    try {
      // Parsear la fecha (formato: "06/09/2025 06:09:18")
      const date = new Date(dateTimeString);
      
      // Verificar si la fecha es válida
      if (isNaN(date.getTime())) {
        return dateTimeString; // Retornar el string original si no se puede parsear
      }
      
      // Función auxiliar para rellenar con ceros
      const padZero = (num: number): string => {
        return num < 10 ? '0' + num : num.toString();
      };
      
      // Formatear a dd/MM/yyyy HH:mm:ss
      const day = padZero(date.getDate());
      const month = padZero(date.getMonth() + 1);
      const year = date.getFullYear();
      const hours = padZero(date.getHours());
      const minutes = padZero(date.getMinutes());
      const seconds = padZero(date.getSeconds());
      
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      return dateTimeString; // Retornar el string original en caso de error
    }
  }

  // Función para verificar si el actuador tiene datos de distance
  hasDistanceData(actuator: any): boolean {
    if (!actuator || !actuator.sensorValues) return false;
    
    return actuator.sensorValues.some((sv: any) => 
      sv.valueDate && (
        sv.name === 'distance' || 
        sv.nomenclature === 'distance' || 
        sv.und === 'm' || 
        sv.und === 'km'
      )
    );
  }

  // Función para obtener la fecha de los datos de distance
  getDistanceDataDate(actuator: any): string {
    if (!actuator || !actuator.sensorValues) return '';
    
    const distanceSensor = actuator.sensorValues.find((sv: any) => 
      sv.valueDate && (
        sv.name === 'distance' || 
        sv.nomenclature === 'distance' || 
        sv.und === 'm' || 
        sv.und === 'km'
      )
    );
    
    return distanceSensor ? this.formatDateTime(distanceSensor.valueDate) : '';
  }

  // Métodos para análisis OEE
  getOEESummary(): any {
    // Retornar cache si ya existe
    if (this.oeeSummaryCache) {
      return this.oeeSummaryCache;
    }

    // Filtrar solo telares con encoder (que tengan los datos necesarios)
    const telaresConEncoder = this.getFilteredActuatorsAlternative().filter(actuator => {
      if (!actuator.sensorValues) return false;
      
      // Verificar que tenga al menos run_time, pause_time, distance y projectedQuantity
      const hasRunTime = actuator.sensorValues.some(sv => 
        sv.nomenclature && sv.nomenclature.toLowerCase().includes('run_time')
      );
      const hasPauseTime = actuator.sensorValues.some(sv => 
        sv.nomenclature && sv.nomenclature.toLowerCase().includes('pause_time')
      );
      const hasDistance = actuator.sensorValues.some(sv => 
        sv.nomenclature && sv.nomenclature.toLowerCase().includes('distance')
      );
      const hasProjectedQuantity = actuator.sensorValues.some(sv => 
        sv.projectedQuantity && !isNaN(parseFloat(sv.projectedQuantity))
      );
      
      return hasRunTime && hasPauseTime && hasDistance && hasProjectedQuantity;
    });

    if (telaresConEncoder.length === 0) {
      this.oeeSummaryCache = null;
      return null;
    }

    let totalTimeOn = 0;
    let totalTimePause = 0;
    let totalDistance = 0;
    let totalIdealDistance = 0;
    let totalActuators = 0;

    console.log("getOEESummary telaresConEncoder", telaresConEncoder.length, "telares");
    console.log("Telares filtrados:", telaresConEncoder.map(t => t.name || t.sensor));

    telaresConEncoder.forEach(actuator => {
      if (actuator.sensorValues) {
        let actuatorProjectedQuantity = 0;
        
        actuator.sensorValues.forEach(sv => {
          const value = parseFloat(sv.value);
          if (!isNaN(value)) {
            // Tiempo activo (run_time)
            if (sv.nomenclature && sv.nomenclature.toLowerCase().includes('run_time') && sv.und && sv.und.toLowerCase().includes('s')) {
              totalTimeOn += value;
            } 
            // Tiempo pausa (pause_time)
            else if (sv.nomenclature && sv.nomenclature.toLowerCase().includes('pause_time') && sv.und && sv.und.toLowerCase().includes('s')) {
              totalTimePause += value;
            } 
            // Distancia producida (distance)
            else if (sv.nomenclature && sv.nomenclature.toLowerCase().includes('distance') && sv.und && sv.und.toLowerCase().includes('m')) {
              totalDistance += value;
            }
          }
          
          // Usar projectedQuantity como distancia ideal (solo una vez por actuador)
          if (sv.projectedQuantity && !isNaN(parseFloat(sv.projectedQuantity))) {
            actuatorProjectedQuantity = parseFloat(sv.projectedQuantity);
          }
        });
        
        // Sumar projectedQuantity solo una vez por actuador
        if (actuatorProjectedQuantity > 0) {
          totalIdealDistance += actuatorProjectedQuantity;
          console.log(`Actuador ${actuator.name || actuator.sensor}: projectedQuantity = ${actuatorProjectedQuantity}`);
        }
        
        totalActuators++;
      }
    });

    if (totalActuators === 0) {
      this.oeeSummaryCache = null;
      return null;
    }

    console.log("OEE Calculado:", {
      totalTimeOn,
      totalTimePause,
      totalDistance,
      totalIdealDistance,
      totalActuators
    });
    
    console.log("Detalle por actuador:");
    telaresConEncoder.forEach((actuator, index) => {
      console.log(`Actuador ${index + 1}: ${actuator.name || actuator.sensor}`);
      if (actuator.sensorValues) {
        actuator.sensorValues.forEach(sv => {
          if (sv.projectedQuantity) {
            console.log(`  - ${sv.nomenclature}: projectedQuantity = ${sv.projectedQuantity}`);
          }
        });
      }
    });

    const totalTime = totalTimeOn + totalTimePause;
    const availability = totalTime > 0 ? (totalTimeOn / totalTime) * 100 : 0;
    const performance = totalIdealDistance > 0 ? (totalDistance / totalIdealDistance) * 100 : 0;
    const quality = 95; // Asumiendo 95% de calidad por defecto
    const totalOEE = (availability * performance * quality) / 10000;

    this.oeeSummaryCache = {
      availability: Math.min(availability, 100),
      performance: Math.min(performance, 100),
      quality: quality,
      total: Math.min(totalOEE, 100),
      totalTimeOn: totalTimeOn,
      totalTimePause: totalTimePause,
      totalDistance: totalDistance,
      totalIdealDistance: totalIdealDistance,
      totalActuators: totalActuators
    };

    return this.oeeSummaryCache;
  }

  // Limpiar cache OEE cuando los datos cambien
  clearOEECache(): void {
    this.oeeSummary = null;
    this.oeeSummaryCache = null;
  }

  // Método específico para regenerar gráficos cuando cambian los filtros
  regenerateGraphics(): void {
    console.log('regenerateGraphics - Regenerando gráficos con filtros actualizados');
    
    // Limpiar cache de vibración para que se recalcule con datos filtrados
    this.vibrationSummary = null;
    
    // Limpiar gráficos existentes
    this.clearExistingCharts();
    
    // Regenerar gráficos inmediatamente
    setTimeout(() => {
      this.generateTelarCharts();
      this.changeDetector.detectChanges();
    }, 100);
  }

  // Método para limpiar gráficos existentes
  clearExistingCharts(): void {
    const chartIds = [
      'telarStatusChart',
      'timeEfficiencyChart', 
      'oeeChart',
      'vibrationAnalysisChart',
      'valueDistributionChart',
      'productionTrendChart'
    ];
    
    chartIds.forEach(chartId => {
      const canvas = document.getElementById(chartId) as HTMLCanvasElement;
      if (canvas) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
    });
  }

  // Forzar actualización de vistas cuando cambien los filtros
  triggerViewUpdate(): void {
    this.filterUpdateTrigger++;
    
    // Limpiar cache de vibración para que se recalcule con datos filtrados
    this.vibrationSummary = null;
    
    // Regenerar gráficos con datos filtrados
    if (this.groupingType === 'type') {
      setTimeout(() => {
        this.generateTelarCharts();
        this.changeDetector.detectChanges();
      }, 100);
    } else {
      // Forzar detección de cambios después de un pequeño delay
      setTimeout(() => {
        this.changeDetector.detectChanges();
      }, 0);
    }
  }

  // Método trackBy para ngFor
  trackByActuator(index: number, actuator: any): any {
    return actuator ? actuator.id : index;
  }

  getOEEStatusClass(type: string, value?: number): string {
    // Si se proporciona un valor específico, usarlo directamente
    if (value !== undefined) {
      if (value >= 90) return 'oee-excellent';
      if (value >= 80) return 'oee-good';
      if (value >= 70) return 'oee-average';
      return 'oee-poor';
    }
    
    // Si no se proporciona valor, usar el resumen total (compatibilidad hacia atrás)
    const summary = this.getOEESummary();
    if (!summary) return '';
    
    let summaryValue = 0;
    switch (type) {
      case 'availability':
        summaryValue = summary.availability;
        break;
      case 'performance':
        summaryValue = summary.performance;
        break;
      case 'quality':
        summaryValue = summary.quality;
        break;
      case 'total':
        summaryValue = summary.total;
        break;
    }
    
    if (summaryValue >= 90) return 'oee-excellent';
    if (summaryValue >= 80) return 'oee-good';
    if (summaryValue >= 70) return 'oee-average';
    return 'oee-poor';
  }

  getOEEStatusText(): string {
    const summary = this.getOEESummary();
    if (!summary) return 'Sin datos';
    
    const total = summary.total;
    if (total >= 90) return 'Excelente';
    if (total >= 80) return 'Bueno';
    if (total >= 70) return 'Promedio';
    return 'Necesita mejora';
  }

  getOEERecommendation(): string {
    const summary = this.getOEESummary();
    if (!summary) return 'Recopilando datos...';
    
    const { availability, performance, quality } = summary;
    
    if (availability < 80) {
      return 'Mejorar tiempo de actividad - revisar paradas no planificadas';
    } else if (performance < 80) {
      return 'Optimizar velocidad de producción - revisar eficiencia de máquinas';
    } else if (quality < 90) {
      return 'Mejorar calidad - revisar procesos y calibración';
    } else {
      return 'Mantener excelente rendimiento actual';
    }
  }

  // Función para calcular OEE por cada telar individual
  getOEEPerTelar(): any[] {
    console.log('=== getOEEPerTelar START ===');
    const filteredActuators = this.getFilteredActuatorsAlternative();
    console.log('getOEEPerTelar - filteredActuators:', filteredActuators);
    console.log('getOEEPerTelar - filteredActuators.length:', filteredActuators.length);
    
    const telaresConEncoder = filteredActuators.filter(actuator => {
      console.log('getOEEPerTelar - checking actuator:', actuator.name || actuator.sensor);
      console.log('getOEEPerTelar - actuator.sensorValues:', actuator.sensorValues);
      
      if (!actuator.sensorValues) {
        console.log('getOEEPerTelar - no sensorValues, skipping');
        return false;
      }
      
      // Verificar que tenga al menos run_time, pause_time, distance y projectedQuantity
      const hasRequiredData = actuator.sensorValues.some(sv => {
        const name = (sv.name || '').toLowerCase();
        const nomenclature = (sv.nomenclature || '').toLowerCase();
        const hasData = name.includes('run_time') || nomenclature.includes('run_time') ||
               name.includes('pause_time') || nomenclature.includes('pause_time') ||
               name.includes('distance') || nomenclature.includes('distance');
        
        if (hasData) {
          console.log('getOEEPerTelar - found required data in sensor:', sv.name, sv.nomenclature);
        }
        
        return hasData;
      });
      
      console.log('getOEEPerTelar - hasRequiredData:', hasRequiredData);
      return hasRequiredData;
    });
    
    console.log('getOEEPerTelar - telaresConEncoder:', telaresConEncoder);
    console.log('getOEEPerTelar - telaresConEncoder.length:', telaresConEncoder.length);

    return telaresConEncoder.map(actuator => {
      console.log('getOEEPerTelar - mapping actuator:', actuator.name || actuator.sensor);
      let runTime = 0;
      let pauseTime = 0;
      let distance = 0;
      let projectedQuantity = 0;
      let actualQuantity = 0;

      // Extraer datos del actuador
      actuator.sensorValues.forEach(sv => {
        const name = (sv.name || '').toLowerCase();
        const nomenclature = (sv.nomenclature || '').toLowerCase();
        const value = parseFloat(sv.value);
        const valuePQ = parseFloat(sv.projectedQuantity);
        console.log(`getOEEPerTelar - sensor: ${sv.name} (${sv.nomenclature}), value: ${sv.value}, parsed: ${sv.projectedQuantity}`);
        
        if (!isNaN(value)) {
          if (name.includes('run_time') || nomenclature.includes('run_time')) {
            runTime = value;
            console.log('getOEEPerTelar - set runTime:', runTime);
          } else if (name.includes('pause_time') || nomenclature.includes('pause_time')) {
            pauseTime = value;
            console.log('getOEEPerTelar - set pauseTime:', pauseTime);
          } else if (name.includes('distance') || nomenclature.includes('distance')) {
            distance = value;
            // Solo obtener projectedQuantity del sensor de distancia
            if (!isNaN(valuePQ)) {
              projectedQuantity = valuePQ;
            }
            console.log('getOEEPerTelar - set distance:', distance, 'projectedQuantity:', projectedQuantity);
          }
        }
      });

      // Calcular métricas OEE para este telar
      const totalTime = runTime + pauseTime;
      const availability = totalTime > 0 ? (runTime / totalTime) * 100 : 0;
      
      // Calcular rendimiento sin límite máximo
      let performance = 0;
      if (projectedQuantity > 0) {
        const calculatedPerformance = (distance / projectedQuantity) * 100;
        
        // No limitar el rendimiento, mostrar el valor real calculado
        performance = calculatedPerformance;
        
        if (calculatedPerformance > 100) {
          console.log(`getOEEPerTelar - Rendimiento superior al 100% (${calculatedPerformance.toFixed(2)}%) para telar: ${actuator.name || 'Desconocido'}`);
          console.log(`  - Producción real: ${distance}m, Capacidad proyectada: ${projectedQuantity}m`);
        }
      }
      
      const quality = distance > 0 ? Math.min(100, (distance / Math.max(distance, 1)) * 100) : 0;
      const totalOEE = (availability * performance * quality) / 10000;

      const result = {
        name: actuator.name || actuator.sensor || 'Telar',
        availability: Math.round(availability * 10) / 10,
        performance: Math.round(performance * 10) / 10,
        quality: Math.round(quality * 10) / 10,
        total: Math.round(totalOEE * 10) / 10,
        runTime,
        pauseTime,
        distance,
        projectedQuantity,
        actualQuantity
      };
      console.log('getOEEPerTelar - final result for actuator:', result);
      return result;
    });
  }


  private padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  hasVibrationData(actuator: any): boolean {
    if (!actuator || !actuator.sensorValues) {
      return false;
    }

    const vibrationValues = this.getVibrationSensorValues(actuator.sensorValues);
    return vibrationValues.length > 0;
  }

  getVibrationRMS(actuator: any): number {
    // Usar la misma lógica que calculateVibrationSummary() pero para cada actuador individual
    if (!actuator || !actuator.sensorValues) {
      return 0.000;
    }

    const vibrationValues = this.getVibrationSensorValues(actuator.sensorValues);
    
    if (vibrationValues.length === 0) {
      return 0.000;
    }

    // Extraer valores de aceleración y velocidad
    const accX = this.getVibrationValue(vibrationValues, 'acceleration_x');
    const accY = this.getVibrationValue(vibrationValues, 'acceleration_y');
    const accZ = this.getVibrationValue(vibrationValues, 'acceleration_z');
    const velX = this.getVibrationValue(vibrationValues, 'velocity_x');
    const velY = this.getVibrationValue(vibrationValues, 'velocity_y');
    const velZ = this.getVibrationValue(vibrationValues, 'velocity_z');

    // Calcular RMS (Root Mean Square) de velocidad - igual que en calculateVibrationSummary()
    const velRms = Math.sqrt(velX * velX + velY * velY + velZ * velZ);

    return velRms;
  }

  getVibrationStatusClass(rmsValue: number): string {
    if (rmsValue === 0) return 'vibration-no-data';
    if (rmsValue < 1.8) return 'vibration-good';    // green
    if (rmsValue < 4.5) return 'vibration-warning';  // yellow
    if (rmsValue < 7.1) return 'vibration-orange';   // orange
    return 'vibration-danger';                       // red
  }

  getVibrationStatusText(rmsValue: number): string {
    if (rmsValue === 0) return 'Sin Datos';
    if (rmsValue < 1.8) return 'DENTRO DE LÍMITES';  // green
    if (rmsValue < 4.5) return 'EN AUMENTO';         // yellow
    if (rmsValue < 7.1) return 'REQUIERE REVISIÓN';  // orange
    return 'CRÍTICO';                                // red
  }

  onItemSelect(item: any) {

    this.filterIOT.push(item.id);
    this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit.filter(
        _ => {
          return this.filterIOT.indexOf(_.id) > -1
        }
      );

     this.dataStreaming = this.dataStreamingColumnSensorsInit.filter(
      _ => {
        return this.filterIOT.indexOf(_.id) > -1
      }
    ); 
   //
   // if(this.showTypeSelect == '2'||this.showTypeSelect == '1'){
      this.getList();
    //}
  }
  /*
  changeItem(item: any){
    this.filterIOT.push(item.id);
    this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit.filter(
        _ => {
          return this.filterIOT.includes(_.id);
        }
      );

     this.dataStreaming = this.dataStreamingColumnSensorsInit.filter(
      _ => {
        return this.filterIOT.includes(_.id);
      }
    ); 
   //
   // if(this.showTypeSelect == '2'||this.showTypeSelect == '1'){
     // this.getList();
    //}
  } */

  onFilterChange(item: any){
    console.log("onFilterChange",item);
  }

  onDeSelect(item: any) {
    /*this.dataStreamingColumnSensors = this.dataStreamingColumnSensors.filter(
      _ => {
        return !this.filterIOT.includes(_.id) || _.id != item.id;
      }
    );

    this.dataStreaming = this.dataStreaming.filter(
      _ => {
        return !this.filterIOT.includes(_.id);
      }
    );*/
    console.log("select item ", item )
    console.log("select DEL ", this.filterIOT )
    this.filterIOT =this.filterIOT.filter(
      x => {
        return x != item.id
      }
    );
    this.getList();
  }

  onSelectAll(items: any) {
    if(this.filterIOT.length>0){
      this.filterIOT = [];
      console.log("onSelectAll",items);
    }

    if(items.length == 0){
      this.filterIOT = [];
    }else{
      console.log("dataStreamingColumnSensorsInit",this.dataStreamingColumnSensorsInit);
      this.filterIOT = this.dataStreamingColumnSensorsInit;
    }
    console.log("filterIOT onSelectAll",this.filterIOT);
    this.getList();
  }

  getSensors(){
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      idZone: this.zoneSelect,
      idGateway: this.gatewaySelect
    }
    this.spinner.show();
    this.panelIOTService.getList(filter).subscribe((_) => {
      this.sensors = [];
      if(_.error == null){
        var s = _.data;//.filter(x => x.stateSensor != "instalado");
        this.paneliotSearch=this.sensors.concat(s);

        console.log("sensors paneliotsearch",this.paneliotSearch);
      }
      this.spinner.hide();
    });
  }

  getGuardTotalTQ(){
    this.actuatorService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe((response) => {
      var actuators = response.data.filter(x => x.idActuatorType == 1);
      var totalguards = 0;
      actuators.forEach(x => {
        totalguards = totalguards + x.minCapacity;
      });
      this.guardTotalTQ = totalguards.toFixed(2);
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  showTable(event: MatSlideToggleChange){
    this.initPage = true;
    this.showLavelSensorsTable = event.checked;
    event.checked = this.showLavelSensorsTable ? false : true;
    if(!event.checked){
      this.createLabelValueSensors();
    }else{
      this.removeLabelValueSensors();
    }
  }
  /*
  showView(event: any){
    this.showTypeSelect = null;
    var panel = Number(event.value);
    this.showTypeSelect = panel.toString();
    if(panel==1){
      this.checkedGrafica = false;
      this.checkedTabla = false;
      this.checkedMapa = true;
      this.displayListStadistics = 'block';
      this.getZones();
    }else{
      if(panel==2){
        this.checkedGrafica = false;
        this.checkedTabla = true;
        this.checkedMapa = false;
        this.displayListStadistics = 'none';
      }else if(panel==3){
        this.checkedGrafica = true;
        this.checkedTabla = false;
        this.checkedMapa = false;
        this.displayListStadistics = 'none';
      }
      this.getList();
    }
  }
    */

    selectView(panel: number) {
    this.showTypeSelect = panel.toString();

    this.checkedGrafica = panel === 3;
    this.checkedTabla = panel === 2;
    this.checkedMapa = panel === 1;

    if (panel === 1) {
      this.displayListStadistics = 'block';
      this.getZones();
    } else {
      this.displayListStadistics = 'none';
      this.getList();
    }
  }

  showDetailSensor(item){
    var existZone = this.zoneSelect;
    this.zoneSelect = item.idZone;
    if(existZone == 0){
      this.getGateways();
    }
  }

  getCanvas() {
    this.canvas = new fabric.Canvas('canvas',{
      selection: true,
      allowTouchScrolling: true,
      enableRetinaScaling: true
    });
  }

  getBackgroundColor(state: number): string {
    switch (state) {
      case 0: return '#e53935'; // rojo: error
      case 1: return '#43a047'; // verde: ok
      case 2: return '#fbc02d'; // amarillo: advertencia
      default: return '#9e9e9e'; // gris: desconocido
    }
  }

  changeEnterprise(data) {
    this.countMaxUserByEnterprise = this.enterprises.find(f => f.enterpriseId == data.value).maximumUsers;
    this.enterpriseSelect = data.value;
    this.gatewaySelect = 0;
    this.headquarterSelect = 0;
    this.headquarters = [];
    this.gateways = [];
    this.getHeadquarters();
  }

  getEnterprises() {
    if (this.isAdminGys) {
      this.spinner.show();
      this.enterpriseService.getEnterprises().subscribe((response) => {
        this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
        this.enterpriseSelect = this.enterprises[0]["enterpriseId"];
        this.spinner.hide();
        this.getHeadquarters();
      },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
    } else {
      this.enterpriseSelect = +localStorage.getItem(AppConstants.Session.ENTERPRISE)
      this.getEnterpriseById(this.enterpriseSelect);
      this.getList();
    }
  }

  getHeadquarters(){
    if (this.isAdminGys) {
      this.spinner.show();
      this.headquarterService.getListAll().subscribe((response) => {
        if(response.error == null){
          this.headquarters = response.data.filter(f => f.idEnterprise == this.enterpriseSelect);
          if(this.headquarters.length > 0){
            this.headquarterSelect = this.headquarters[0].id;
          }
          this.spinner.hide();
          this.getZones();
          this.getShifts();
          this.getGateways();
        }else{
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        }
      },
        (error: HttpErrorResponse) => {
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        });
    } else {
      this.headquarterSelect = +localStorage.getItem(AppConstants.Session.HEADQUARTER);
    }
  }

  getGateways(){
    this.gatewayService.getListAll().subscribe((response) => {
      if(response.error == null){
        if(this.headquarterSelect == 0){
          var gateways = response.data.filter(x => x.idEnterprise == this.enterpriseSelect);
          this.gateways = gateways;
        }else{
          var gateways = response.data.filter(x => x.idEnterprise == this.enterpriseSelect && x.idHeadquarter == this.headquarterSelect);
          this.gateways = gateways;
        }
        if(this.gateways.length > 1){
          this.isGuardTotal = false;
          this.gatewaySelect = 0;
          this.guardTotal = "0";
        }else{
          this.isGuardTotal = this.gateways[0].isGuardTotal == 1 ? true : false;
          this.gatewaySelect = this.gateways[0].id;
          this.guardTotal = gateways[0].guardTotal.toFixed(2);
        }
      }else{
        this.gateways = [];
      }
      this.getList();
    },
      (error: HttpErrorResponse) => {
        this.gateways = [];
      });
  }

  showGuardTank(){
    let dialogRef = this.dialog.open(ActuatorDetailPanelModalComponent, {
      data: {
        title: AppConstants.TitleModal.LIST_ACTUATOR_PANEL_IOT,
        action: AppConstants.OperationType.UPDATE,
        headquarters: this.headquarters,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idGateway: this.gatewaySelect,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        color: this.color1,
        colorFont: this.color2,
        obj:null},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.guardTotalTQ = _.totalguard;
      }
    });
  }

  getZones(){
    this.zoneService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe((response) => {
      if(response.error == null){
        this.zones = response.data.filter(x => x.type == 2);
        if(this.zones.length>0){
          if(this.zoneSelect != 0){
            var zone = response.data.filter(x => x.id == this.zoneSelect);
            if(zone.length>0){
              this.zoneSelect = zone[0].id;
              var image = zone[0].image;
              this.imageZone = image;
              this.headquarterSelect = zone[0].idHeadquarter;
              this.getGateways();
            }
          }else{
            if(response.data.length > 0){
              this.zoneSelect = response.data[0].id;
              this.imageZone = response.data[0].image;
              this.headquarterSelect = response.data[0].idHeadquarter;
            }
            this.getGateways();
            /*this.zoneSelect = this.zones[0].id;
            var image2 = this.zones[0].image;
            this.imageZone = image2;

            if(this.showTypeSelect == '1'){
              this.changeImage(image2);
            }

            this.headquarterSelect = this.zones[0].idHeadquarter;
            this.getGateways();*/
          }
          this.getSensors();
        } else {
          this.alertService.showMessage("No tiene zonas IOT registradas, debes de crear una zona para usar este módulo", "", MessageSeverity.error);
          if(this.showTypeSelect == '1'){
            this.changeImage('./assets/images/sin_image.jpg');
          }
        }
      }
    });
  }

  getShifts() {
    this.shiftService.getListAll(this.enterpriseSelect, this.headquarterSelect).subscribe((response) => {
      if (response.error == null) {
        this.shifts = response.data || [];
      } else {
        this.shifts = [];
        console.error('Error al cargar turnos:', response.error);
      }
    }, (error) => {
      this.shifts = [];
      console.error('Error al cargar turnos:', error);
    });
  }

  getEnterpriseById(enterpriseId: number) {
    this.spinner.show();
    this.enterpriseService.getEnterpriseById(enterpriseId).subscribe((response => {
      this.countMaxUserByEnterprise = response.maximumUsers;
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getGraphs(){
    var s = [];
    this.sensors.forEach(_ =>{
      s.push({
        Id: _.id,
        IdSensor: _.idSensor,
        Nomenclature : _.nomenclature,
        ValueType: _.valueType,
        Und: _.und,
        IndexGraphValueType: _.indexGraphValueType
      });
    });
    var _this = this;
    this.panelIOTService.getListGraphs({
      "Sensors":s
    }).subscribe((_) => {
      _this.dataStreamingColumnSensors.forEach(__ =>{
        if(_.data){
          var g = _.data.filter(x => x.id == __.id);
          if(g.length > 0){
            __.graphSensor = g[0].graphSensor;
            let sum = 0;
            /*if(__.graphSensor[0].LabelUnd == "Kwh"){
              __.graphSensor[0].DataSets[0].data.filter(y =>{
                sum = sum + parseFloat(y);
              });
            }else{
              __.graphSensor[0].DataSets[0].data.filter(y =>{
                sum = sum + parseFloat(y);
              });
            }*/
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              console.log("y",y);
              sum = sum + parseFloat(y);
            });
            if(__.valueType == "Flujo"){
              let slash = __.und.indexOf("/");
              var und = __.und.substring(0, slash);
              console.log("item",__);
              if(__.valueSum24Hours != "-" && __.valueSum24Hours){
                console.log("__.valueSum24Hours: " + __.valueSum24Hours+ "||| und:"+und);
                __.valueSum24Hours = parseFloat(__.valueSum24Hours).toFixed(2) + " " + und;
              }
              __.valueAVG24Hours = (sum/24).toFixed(2) + " " + und;
            }else{
              __.valueSum24Hours = sum.toFixed(2) + " " + __.und;
              __.valueAVG24Hours = (sum/24).toFixed(2) + " " + __.und;
            }
          }
        }
       
      });

      _this.dataStreamingColumnActuators.forEach(__ => {
        if(_.data != null){
          var g = _.data.filter(x => x.id == __.id);
          if(g.length > 0){
          __.graphSensor = g[0].graphSensor;
          let sum = 0;
          /*if(__.graphSensor[0].LabelUnd == "Kwh"){
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }else{
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }*/
          __.graphSensor[0].DataSets[0].data.filter(y =>{
            console.log("y",y);
            sum = sum + parseFloat(y);
          });
          if(__.valueType == "Flujo"){
            let slash = __.und.indexOf("/");
            var und = __.und.substring(0, slash);
            console.log("item",__);
            if(__.valueSum24Hours != "-" && __.valueSum24Hours){
              console.log("__.valueSum24Hours: " + __.valueSum24Hours+ "||| und:"+und);
              __.valueSum24Hours = parseFloat(__.valueSum24Hours).toFixed(2) + " " + und;
            }
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + und;
          }else{
            __.valueSum24Hours = sum.toFixed(2) + " " + __.und;
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + __.und;
          }
        }
        }
      });
      _this.showGraphSensorPanel = true;
      //calculate sum y prom
      _this.dataStreamingColumnSensors.forEach(ds => {

      });
    });
  }

  getList(){
   // this.spinner.show();
      this.loadData = true;
      // Limpiar cache OEE cuando se actualicen los datos
      this.clearOEECache();
      if(!this.isPhone && this.showTypeSelect == '1'){
        this.getCanvas();
        console.log("zone",this.imageZone);
        this.changeImage(this.imageZone);
      }
      // Usar la fecha seleccionada o la fecha actual como fallback
      let dateToUse = this.currentDate;
      if (this.dateSelect) {
        // Convertir el objeto Date a formato YYYY-MM-DD
        const year = this.dateSelect.getFullYear();
        const month = this.padZero(this.dateSelect.getMonth() + 1);
        const day = this.padZero(this.dateSelect.getDate());
        dateToUse = `${year}-${month}-${day}`;
        console.log('Fecha seleccionada convertida:', dateToUse);
      }
      
      var filter = {
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idZone: this.zoneSelect,
        idGateway: this.gatewaySelect,
        date: dateToUse,
        idShift: this.shiftSelect,
        startHour: this.shiftStartTime,
        endHour: this.shiftEndTime
      }
      
      console.log('Payload enviado:', filter);
      console.log('shiftSelect en getList:', this.shiftSelect);
      var contentTotal = 0;
      this.dataStreaming = [];
      this.sensorTypesCountEnabled = [];
      this.sensorTypesCountDisabled = [];
      this.sensorTypesCountEnabledObj= new Map<String, String>();
      this.sensorTypesCountDisabledObj= new Map<String, String>();
      var repetidosEnabled = {};
      var repetidosDisabled = {};
      var _this = this;
      this.panelIOTService.getList(filter).subscribe((_) => {
        if(_.error == null){
          var d = _.data;
          if(this.filterIOT.length>0){
            d = _.data.filter(c =>{ return this.filterIOT.filter(x => x === c.id) });
          }

          this.qtyEnabled = d.filter(f => { return f.state == 1 }).length;
          this.qtyDisabled = d.filter(f => { return f.state != 1 }).length;
          var iii = 0;

          d.forEach(x =>{
            if(x.graphSensor == null || !x.graphSensor){
              x.graphSensor = {
                DataSets: []
              }
            }

            if(x.isActuator){ //Actuators
                if(x.idActuatorType == 1){ //TANQUE
                  this.isTank = true;
                  contentTotal += parseFloat(x.value);
                    var porc = Math.round((parseFloat(x.value)*100)/x.maxCapacity);
                    if(porc <= 0){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque1.png";
                    }else if(porc <= 25 && porc > 0){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque2.png";
                    }else if(porc <= 50 && porc > 25){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque3.png";
                    }else if(porc <= 75 && porc > 50){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque4.png";
                    }else if(porc <= 99 && porc > 75){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque5.png";
                    }else if(porc > 99){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque6.png";
                    }

                    if(x.state == 1){
                      this.sensorTypesCountEnabled.push(environment.storage + "/pin/actuator/Tanque6.png");
                    }else{
                      this.sensorTypesCountDisabled.push(environment.storage + "/pin/actuator/Tanque6.png");
                    }

                    x.imgDensity = environment.storage + "/actuator/density/aceite.png";
                    if(x.density < 0.90 && x.density > 0.93){
                      x.imgDensity = environment.storage + "/actuator/density/agua.png";
                    }


                  }else if(x.idActuatorType == 2){//valvula
                    x.imgActuator = environment.storage + "/pin/actuator/Valvula"+x.state+".png";
                    x.imgActuatorColumn = environment.storage + "/actuator/valvula/valvula_"+x.state+".png";
                  }else if(x.idActuatorType == 3){//poza
                    this.isPoza = false;// true;
                    console.log("x.value",x.value);
                    if(x.value=="1"){
                      x.imageActuator = "https://stplataformaindustriadev.blob.core.windows.net/setting/actuator/valvula-on.png";
                    }else if(x.value=="0"){
                      x.imageActuator2 = "https://stplataformaindustriadev.blob.core.windows.net/setting/actuator/valvula-off.png";
                    }
                  }else if(x.idActuatorType == 5){//telar
                    this.isTelar = true;
                    if(x.state == 1){
                      this.sensorTypesCountEnabled.push(x.pin);
                    }else{
                      this.sensorTypesCountDisabled.push(x.pin);
                    }
                  }

          }else{ //SENSORS
            if(x.nomenclatureSensorType == 'N'){
              x.imgSensorColumn = environment.storage + "pin/sensor/radar/radar.png";
            }else if(x.nomenclatureSensorType == 'EE'){
                if(x.value== null){
                  x.percentContent = 0;
                  x.imageGaugePercentContent = environment.storage + "pin/sensor/gauges/GaugeAmp1.png";
                }else{
                  var porc = parseFloat(x.value);
                  var porce = Math.round((parseFloat(x.value)*100)/6000);
                  x.percentContent = porce;
                    x.imageGaugePercentContent = environment.storage + "/pin/Cosa1.png";
                    x.value = "kw uh: " + parseFloat(x.value).toFixed(2).toString();// + " "+ x.und;
                    x.valueTotal = "kw total: " + parseFloat(x.valueTotal).toFixed(2).toString();//  + " "+ x.und;
                  }
            }else if(x.nomenclatureSensorType == 'F'){
              if(!x.value){ x.value = "0"; }
              var porc = parseFloat(x.value);
              var porce = Math.round((parseFloat(x.value)*100)/1200);
              x.percentContent = porce;
              x.imageGaugePercentContent = environment.storage + "/pin/Cosa2.png";
              x.value = parseFloat(x.value).toFixed(2).toString() + " "+ x.und;
            }else{
              if(!x.value){ x.value = "0"; }
              var porc = parseFloat(x.value);
              var porce = Math.round((parseFloat(x.value)*100)/1200);
              x.percentContent = porce;
              x.imageGaugePercentContent = environment.storage + "/pin/Sensor999.png";
              x.value = parseFloat(x.value).toFixed(2).toString() + " "+ x.und;
            }


              if(x.state == 1){
                this.sensorTypesCountEnabled.push(x.pin);
              }else{
                this.sensorTypesCountDisabled.push(x.pin);
              }

         }


              if(x.idSensors){
                if (x.idSensors.indexOf(',') > -1)
                {
                  x.sensors = x.idSensors.split(",");
                }else{
                  x.sensors = [x.idSensors];
                }
              }

            if(x.idActuators){
              if (x.idActuators.indexOf(',') > -1)
              {
                x.actuators = x.idActuators.split(",");
              }else{
                x.actuators = [x.idActuators];
              }
              var minC = parseFloat(x.minCapacity.toString());
              x.minCapacity = +(minC.toFixed(2)).toString();
              
              x.percentContent = +((((parseFloat(x.value.toString())/100) / (parseFloat(x.maxCapacity.toString())/100)))*100).toFixed(2);
              if(x.percentContent < 1){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent0.png";
              }else if(x.percentContent >= 1 && x.percentContent <= 25){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent25.png";
              }else if(x.percentContent > 25 && x.percentContent <= 50){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent50.png";
              }else if(x.percentContent > 50 && x.percentContent <= 75){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent75.png";
              }else if(x.percentContent > 75 &&  x.percentContent < 100){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent85.png";
              }else if(x.percentContent >= 100){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent100.png";
              }
            }
            iii++;
          });

          this.sensors = d;
          this.dataStreaming = d;
          this.dataStreamingColumn = d.filter(x => x.idActuatorType == 1 || x.idActuatorType == 3 || x.idActuatorType == 5); //tanque || poza
          console.log("dataStreamingColumn",this.dataStreamingColumn);
          this.dataStreamingColumnActuators = d.filter(x => x.isActuator == 1 && x.idActuatorDataType != 2);
          if(this.showAllHeadquarters){
            var headquarters = JSON.parse(
              localStorage.getItem(AppConstants.Session.HEADQUARTERS)
            );
            var dataStreamingColumnHeadquartersActuators = [];
            var i = 0;
            headquarters.forEach(element => {
              console.log(element.name);
              if(this.dataStreamingColumnActuators[i]){
              //  this.dataStreamingColumnActuators[i].sensor= element.name;
                dataStreamingColumnHeadquartersActuators.push(this.dataStreamingColumnActuators[i]);
              }
              i++;
            });
            console.log("dataStreamingColumnHeadquartersActuators",dataStreamingColumnHeadquartersActuators);
            this.dataStreamingColumnActuators = dataStreamingColumnHeadquartersActuators;
          }

          this.dataStreamingColumnSensors =  d;//.filter(x => x.isActuator != 1);
          this.dataStreamingColumnSensorsInit = this.dataStreamingColumnSensors;
          this.panelIOTService.setDataStreamingSensors(this.sensors);
          this.showSensorsGraphs = true;
          
          // Procesar datos agrupados para la vista gráfica
          if (this.showTypeSelect === '3') {
            this.processGroupedData();
          }
          var _this = this;
          if(!this.isPhone && this.showTypeSelect == '1'){
                var canvas =  new fabric.Canvas("canvas");
                canvas.setWidth(1000);
                canvas.setHeight(500);
                _this.createMarkers();
                _this.createValueSensor();
          }

          _this.contentTotal = contentTotal.toFixed(2);
        }
        this.spinner.hide();
        this.loadData = false;

        console.log("dataStreamingColumnActuators",this.dataStreamingColumnActuators);

        // Debug: Mostrar qué se está contando
        console.log("sensorTypesCountEnabled (antes del conteo):", this.sensorTypesCountEnabled);
        console.log("sensorTypesCountDisabled (antes del conteo):", this.sensorTypesCountDisabled);

        this.sensorTypesCountEnabled.forEach(function(numero){
          repetidosEnabled[numero] = (repetidosEnabled[numero] || 0) + 1;
        });

        this.sensorTypesCountDisabled.forEach(function(numero){
          repetidosDisabled[numero] = (repetidosDisabled[numero] || 0) + 1;
        });

        console.log("repetidosEnabled:", repetidosEnabled);
        console.log("repetidosDisabled:", repetidosDisabled);

        Object.keys(repetidosEnabled).forEach(key => {
          this.sensorTypesCountEnabledObj.set(key,repetidosEnabled[key]);
        });
        Object.keys(repetidosDisabled).forEach(key => {
          this.sensorTypesCountDisabledObj.set(key,repetidosDisabled[key]);
        });
        
        console.log("sensorTypesCountEnabledObj final:", this.sensorTypesCountEnabledObj);
        console.log("sensorTypesCountDisabledObj final:", this.sensorTypesCountDisabledObj);

        this.changeDetector.detectChanges();
        
        // Si estamos en la pestaña de gráficos, regenerar gráficos después de cargar los datos
       // if (this.groupingType === 'type') {
          console.log('getList - Regenerando gráficos después de cargar datos porque estamos en pestaña type');
          setTimeout(() => {
            this.regenerateGraphics();
          }, 200);
       // }
      });
  }

  createMarkers() {
    var objects = this.canvas.getObjects();
    if(objects.lengt){
      for(var ii = 0; ii < objects.length; ii++){
        if(obj.id== objects[ii].id){
          this.canvas.remove(objects[ii]);
        }
      }
    }

    //console.log("sensors", this.sensors.length);
    for (var i = 0; i < this.sensors.length; i++) {
      var obj = this.sensors[i];
      this.newGroup(obj);
    }
  }

  createValueSensor() {
    this.removeActuatorsSensors();
    for (var i = 0; i < this.dataStreaming.length; i++) {
      var obj = this.dataStreaming[i];
      if(obj.idActuatorType != 2){ // no valvulas
        this.newValue(obj);
      }
    }
  }

  createLabelValueSensors() {
    this.removeLabelValueSensors();
    this.removeActuatorsSensors();
    for (var i = 0; i < this.dataStreaming.length; i++) {
      var obj = this.dataStreaming[i];
      if(obj.idActuatorType != 2){ // no valvulas
        this.newValue(obj);
      }
    }
  }

  removeLabelValueSensors(){
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_labelValue" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_labelValue" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
  }

  removeActuatorsSensors(){
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_value" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_value" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
  }

  newValue(obj) {
    if(obj.value == null || obj.value == undefined){ obj.value = 0; }
    //actuator
    if(obj.isActuator){
        if(obj.idActuatorType == 1){ // tanque
        var salveGuarda = "";
        if(!this.isGuardTotal){
          salveGuarda = "\n S:" + obj.minCapacity+ " TN";
        }
        if(obj.percentContent == undefined || !obj.percentContent){
          obj.percentContent = 0;
        }
        var text = new fabric.Text( "V:"+ parseFloat(obj.value).toFixed(2).toString() + " TN (" + obj.percentContent  +"%) \n CM:" + obj.maxCapacity + " TN"+salveGuarda + " \n D: "+obj.density,
        {
          selection: false,
          selectable: false,
          textBorderColor: this.color1,
          textShadow: this.color1,
          backgroundColor: 'transparent',
          fontSize: 12,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: this.color1,
          //fontSize: 20,
          strokeWidth: 0,
          selectionRadius: 20,
          originX: 'center',
          originY: 'center'
        }
          );

          var textBoundingRect = text.getBoundingRect();
          var background = new fabric.Rect({
            top: textBoundingRect.top,
            left: textBoundingRect.left,
            width: textBoundingRect.width,
            height: textBoundingRect.height,
            fill: 'transparent',//'#00000033',
            rx: 5,
            ry: 5,
            objectCaching: false,
          });
          var group = new fabric.Group([background,text], {
            left: parseFloat(obj.posX),
            top: parseFloat(obj.posY)-80,
            borderColor: this.color1,
            strokeWidth: 0,
            selectionRadius: 20,
            rx: 5,
            ry: 5,
            hasControls: false,
            hasRotatingPoint: false,
            id: obj.id+"_value",
            selectable: false,
            selection: false,
            isGraph: 0,
            fill:'red'
            });
            this.canvas.add(group);


            /* densidad */

            var imgDensity = "../../../../../assets/actuator/density/aceite.png";
            var _this= this;
            if(obj.density < 0.90 && obj.density > 0.93){ imgDensity = "../../../../../assets/actuator/density/agua.png";}
            new fabric.Image.fromURL(imgDensity,
              function(img) {
                var img1 = img.set({
                  originX: 'center',
                  originY: 'bottom',
                  top: -10,
                  scaleX: 1,
                  scaleY: 1
                });
                  var group = new fabric.Group([img1], {
                    left: parseFloat(obj.posX)-60,
                    top: parseFloat(obj.posY),
                    borderColor: 'transparent',
                    strokeWidth: 0,
                    selectionRadius: 20,
                    rx: 5,
                    ry: 5,
                    hasControls: false,
                    hasRotatingPoint: false,
                    id: obj.id+"_density",
                    selectable: false,
                    selection: false,
                    isGraph: 0
                  });
                  _this.canvas.add(group);
              });
      }
    }else{//sensor

      /*
      var color = "";
      if(obj.state == 1){
        color = "green";
      }else if(obj.state == 2){
        color = "yellow";
      }else{
        color = "red";
      }

      var _this = this;
      var text = new fabric.Text(obj.sensor, {
        textBorderColor: color, //this.color1,
          textShadow: color, //this.color1,
          backgroundColor: 'transparent',
          fontSize: 15,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: color,//this.color1,
        originX: 'center',
        originY: 'center',});
      var textBoundingRect = text.getBoundingRect();
      var background = new fabric.Rect({
        top: textBoundingRect.top,
        left: textBoundingRect.left,
        width: textBoundingRect.width,
        height: textBoundingRect.height,
        fill: '#00000033',
        rx: 5,
        ry: 5,
        objectCaching: false,
      });
      new fabric.Image.fromURL(obj.pin,
        function(img) {
          var img1 = img.set({
            originX: 'center',
            originY: 'bottom',
            top: -10,
            scaleX: 1,
            scaleY: 1
          });
            var group = new fabric.Group([text,background, img1], {
              left: parseFloat(obj.posX)+10,
              top: parseFloat(obj.posY)+20,
              borderColor: 'transparent',
              strokeWidth: 0,
              selectionRadius: 20,
              rx: 5,
              ry: 5,
              hasControls: false,
              hasRotatingPoint: false,
              id: obj.id+"_value",
              selectable: false,
              selection: false,
              isGraph: 0
            });
            _this.canvas.add(group);
        });

          if(this.showLavelSensorsTable){
            var desc = "";
            if(obj.nomenclature.indexOf('RD') > -1){
              desc = "Altura: ";
            }
            var text2 = new fabric.Text(desc+obj.value.toString(),
            {
              backgroundColor: 'transparent',
              selection: false,
              selectable: false,
              textBorderColor: this.color1,
              textShadow: this.color1,
              textBackgroundColor:'transparent',
              fill: this.color1,
              fontSize: 20,
              strokeWidth: 0,
              selectionRadius: 20,
              originX: 'center',
              originY: 'center'
            }
              );
              var group2 = new fabric.Group([text2], {
                left: parseFloat(obj.posX)+20,
                top: parseFloat(obj.posY)-8,
                borderColor: 'transparent',
                strokeWidth: 0,
                selectionRadius: 20,
                rx: 5,
                ry: 5,
                hasControls: false,
                hasRotatingPoint: false,
                id: obj.id+"_labelValue",
                selectable: false,
                selection: false,
                isGraph: 0
                });
               this.canvas.add(group2);
          }

      */

      const _this = this;

      // Color dinámico según estado
      const backgroundColor = obj.state === 1 ? '#008000' : obj.state === 2 ? '#FFCC00' : '#FF0000';

      // 1. Círculo como base
      const circle = new fabric.Circle({
        radius: 45,
        fill: backgroundColor,
        originX: 'center',
        originY: 'center'
      });

      // 2. Cargar la imagen PIN y crear el grupo completo
      fabric.Image.fromURL(obj.pin, function (img) {
        // Ajustar tamaño de la imagen dentro del círculo
        img.scaleToWidth(40);
        img.scaleToHeight(40);
        img.set({
          originX: 'center',
          originY: 'center',
          top: -25 // más arriba que el valor
        });

        // 3. Texto del valor centrado
        const valueText = new fabric.Text(obj.value.toString(), {
          fontSize: 18,
          fill: '#FFFFFF',
          fontWeight: 'bold',
          originX: 'center',
          originY: 'center',
          top: 10
        });

        // 4. Texto del nombre fuera del círculo, con fondo semitransparente
        const nameBackground = new fabric.Rect({
          width: 100,
          height: 20,
          fill: 'rgba(0,0,0,0.4)',
          originX: 'center',
          originY: 'top',
          top: 48
        });

        const nameText = new fabric.Text(obj.sensor, {
          fontSize: 12,
          fill: '#FFFFFF',
          originX: 'center',
          originY: 'top',
          top: 50
        });

        // 5. Agrupar todo
        const group = new fabric.Group([circle, img, valueText, nameBackground, nameText], {
          left: parseFloat(obj.posX),
          top: parseFloat(obj.posY),
          hasControls: false,
          hasRotatingPoint: false,
          selectable: false,
          id: obj.id,
          isGraph: 0
        });

        _this.canvas.add(group);
      });

    }

  }

  newGroup(obj) {
      // text = new fabric.Text(obj.nomenclature, {selection: false,selectable: false,textBackgroundColor:obj.stateColor,fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});

      var _this = this;
      if(obj.isActuator){
        var color = "";
        if(obj.state == 0){
          color = "green";
        }else if(obj.state == 1){
          color = "gray";
        }else if(obj.state == 2){
          color = "red";
        }
        var text = new fabric.Text(obj.nomenclature, {


          textBorderColor: color,
          textShadow: color,
          backgroundColor: 'transparent',
          fontSize: 15,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: color,
          originX: 'center',
          originY: 'center'});
        var img = "";



       /* if(obj.value != "" && obj.value != null && obj.imageActuator2 != "" && obj.imageActuator2 != null){
          if(obj.value == "1"){
            img = obj.imageActuator2;
          }
        }*/
        /*var scale = 0.7;
        if(obj.idActuatorType == 2){//valvula
          scale = 0.7;
        }*/

        var opacity = 1;
       /* if(obj.state == 4){
          opacity = 0.3;
        }*/

        var scale = 0.8;
        if(obj.idActuatorType != 3){ // No Pozas
         // scale = 0.5;
          new fabric.Image.fromURL(obj.imgActuator,
            function(img) {
              var img1 = img.set({
                originX: 'center',
                originY: 'bottom',
                top: -10,
                scaleX: scale,
                scaleY: scale
              });
                var group = new fabric.Group([text, img1], {
                  left: obj.posX,
                  top: obj.posY,
                  borderColor: 'transparent',
                  hasControls: false,
                  hasRotatingPoint: false,
                  selectable: false,
                  selection: false,
                  opacity: opacity,
                  id: obj.id,
                  isGraph: 0
                });
              // console.log("canvas group",group);
                _this.canvas.add(group);
                _this.nameMarker = '';
            });

        }
      }else{
        var _this = this;
        /* var text = new fabric.Text(obj.nomenclature, {textBackgroundColor:obj.stateColor,fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});


       var group = new fabric.Group([text], {
          left: obj.posX,
          top: obj.posY,
          borderColor: 'transparent',
          hasControls: false,
          hasRotatingPoint: false,
          id: obj.id,
          isGraph: 0
          });
          this.canvas.add(group);*/
      }
      /*
      var group = new fabric.Group([text], {
      left: obj.posX,
      top: obj.posY,
      borderColor: 'transparent',
      hasControls: false,
      hasRotatingPoint: false,
      id: obj.id,
      selectable: false,
      selection: false,
      isGraph: 0
      });
      this.canvas.add(group);*/
  }


  newGraphSensor(obj) {
    var text = new fabric.Text(obj.nomenclature, {textBackgroundColor:'#1f5165',fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});
    var group = new fabric.Group([text], {
    left: obj.posX,
    top: obj.posY + 50,
    borderColor: 'transparent',
    hasControls: false,
    hasRotatingPoint: false,
    id: obj.id
    });
    this.canvas.add(group);
}

  openEditModal(data){
      let dialogRef = this.dialog.open(SensorModalComponent, {
        data: {
          title: AppConstants.TitleModal.UPDATE_SENSOR,
          action: 0,
          gateways: this.gateways,
          headquarters: this.headquarters,
          idEnterprise: this.enterpriseSelect,
          idHeadquarter: this.headquarterSelect,
          idGateway: this.gatewaySelect,
          isAdminGys: this.isAdminGys,
          obj:data},
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        this.getList();
      });
  }

    changeHeadquarter(data) {
      this.headquarterSelect = data.value;
      this.getGateways();
      this.getZones();
    }

    changeGateway(data) {
      this.gatewaySelect = data.value;
      this.getList();
    }

    changeItem(data) {
      this.selectedNomenclature = data.value;
      //console.log('changeItem - selectedNomenclature:', this.selectedNomenclature, 'groupingType:', this.groupingType);
      this.clearOEECache();
      if(this.selectedNomenclature != "0"){
        this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit.filter(x => x.nomenclature == this.selectedNomenclature);
        this.selectedPanelIOT = this.dataStreamingColumnSensors[0].id;
      }else{
        this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit;
        this.selectedPanelIOT = 0;
      }
      
      // Si estamos en la pestaña de gráficos, refrescar datos y regenerar gráficos
     // if (this.groupingType === 'type') {
     //   console.log('changeItem - Refrescando datos y regenerando gráficos porque estamos en pestaña type');
        this.getList(); // Refrescar datos primero
        // Los gráficos se regenerarán automáticamente cuando getList() termine
      //}
      
      this.triggerViewUpdate();
    }

    changeZone(data) {
      //this.spinner.show();
      this.showGraphSensor = false;
      this.zoneSelect = data.value;
      this.filterIOT = [];
      this.paneliotSearch = [];
      this.selectedPanelIOT = 0;
      this.selectedNomenclature = "0";
      this.getSensors();

      if(this.showTypeSelect == "1" && this.zoneSelect == 0){
        this.displayListStadistics = 'none';
        this.showTypeSelect = "3";
      }

      this.selectSensorMenu = 0;
      if(this.showTypeSelect == '1'){
        var zone = this.zones.filter(x => x.id == this.zoneSelect);
        if(zone.length>0)
        {
          this.headquarterSelect = zone[0].idHeadquarter;
          var image = zone[0].image;
          this.imageZone = image;
        }else {
          this.imageZone = './assets/images/sin_image.jpg';
        }
        this.getList();
      }else{
        this.getList();
      }
    }

    changeImage(urlImage : string) {
        var _this = this;
        if(urlImage){
          fabric.Image.fromURL(urlImage, (img) => {
            img.set({
              opacity: 0.5,
              scaleX: _this.canvas.width / img.width,
              scaleY: _this.canvas.height / img.height,
            });
            _this.canvas.setBackgroundImage(img, _this.canvas.requestRenderAll.bind(_this.canvas));
          });
        }
    }

  openModal(id,nomenclature){
    document.getElementById('actuactorPanel'+id).style.display="initial";
    /*document.getElementById('chartLineStreaming'+id+"_").style.display="initial";*/
  }

  openModalGraph(item){
    let dialogRef = this.dialog.open(PanelIotActionModalComponent, {
      data: {
        title: AppConstants.TitleModal.UPDATE_SENSOR,
        action: 0,
        gateways: this.gateways,
        headquarters: this.headquarters,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idGateway: this.gatewaySelect,
        isAdminGys: this.isAdminGys,
        idZone: this.zoneSelect,
        obj:item
      },
      panelClass: 'bg-modal-transparent' ,
      width: this.isPhone ? '250px':'300px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if(_.change){
        this.getList();
      }
    });
  }

    showGraph(){
      var _this = this;
      this.canvas.on("mouse:up", function(e) {
        if(!_this.showGraphSensor && e.target != undefined && e.target != null){
          _this.showGraphSensor = true;
          // console.log("entraaaa if");
          _this.showSensorEdit = true;
          var dataS = null;
          //console.log("sensors",_this.sensors);
          _this.dataStreaming.forEach(g => {
            //console.log(g.id+"-----"+e.target.id+" || "+g.id + "_value"+"-----"+e.target.id);
            if ((g.id == e.target.id || g.id + "_value" == e.target.id) && g.idActuatorType != 3) { // && g.state == 0
              dataS = g;
              _this.openModal(g.id,g.nomenclature);
            }
          });
          _this.showGraphSensor = false;
          _this.showSensorEdit = false;
        }
      });
    }

    save(){
      var data = {
        isGuardTotal: this.isGuardTotal == true ? 1:0,
        guardTotal: this.guardTotal,
        idGateway: this.gatewaySelect,
        idUser: +localStorage.getItem(AppConstants.Session.USERID)
      }
      this.gatewayService.updateSettingGateway(data).subscribe((response) => {
        if(response.message == "" || !response.message){
          this.alertService.showMessage("Se actualizo el total guarda correctamente", "", MessageSeverity.success);
          this.getList();
        }else{
          this.alertService.showMessage("Ocurrió un problema al actualizar el guarda", "", MessageSeverity.error);
        }
      });
    }

    isGuardTotalSwitch(event: MatSlideToggleChange){
        if(event.checked){
          this.isGuardTotal = true;
        }else{
          this.isGuardTotal = false;
        }
    }

    mostrarSensor(item){
      this.selectSensorMenu = item.id;
      this.dataStreamingColumnSensors = this.dataStreamingColumnSensors.filter(x => x.id == item.id);
    }

    mostrarAllSensors(){
      this.selectSensorMenu = 0;
      this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit;
    }

    refresh(){
      this.getList();
    }

    showPozas(idHeadquarter){
      this.showAllHeadquarters = this.showAllHeadquarters ? false : true;
      this.getList();
    }

    // Nuevos métodos para agrupación por gráficos
    setGroupingType(type: string) {
      this.groupingType = type;
      if(type =="type"){
        this.getList();
      }
      //this.getList();
      //console.log('setGroupingType - Cambiando a pestaña:', type);
      this.processGroupedData();
      
      // Si se selecciona registros, cargar datos de ejemplo
      //if (type === 'registros') {
       // this.loadRegistrosProduccion();
      //}
      
      // Si se selecciona gráficos, regenerar inmediatamente
      //if (type === 'type') {
        //console.log('setGroupingType - Regenerando gráficos porque cambiamos a pestaña type');
       // this.regenerateGraphics();
      //}
      
      // Si se selecciona telares, forzar actualización de vista
      //if (type === 'actuator') {
        //console.log('setGroupingType - Forzando actualización de vista porque cambiamos a pestaña actuator');
        this.triggerViewUpdate();
      //}
     // alert(type);
    }

    processGroupedData() {
      if (this.groupingType === 'actuator') {
        this.groupByActuator();
      } else if (this.groupingType === 'sensor') {
        this.groupBySensor();
      } else if (this.groupingType === 'type') {
        this.groupByType();
      }else{
        this.groupByActuator();
      }
    }

    groupByActuator() {
      this.groupedByActuator = [];
      var actuators = [];
      // Obtener todos los actuadores
      if(this.selectedNomenclature != "0"){
        actuators = this.dataStreaming.filter(item => item.isActuator && item.nomenclature == this.selectedNomenclature);
      }else{
        actuators = this.dataStreaming.filter(item => item.isActuator);
      }
     
      
      actuators.forEach(actuator => {
        // Buscar sensores asociados a este actuador
        const associatedSensors = this.dataStreaming.filter(sensor => 
          !sensor.isActuator && 
          actuator.sensors && 
          actuator.sensors.includes(sensor.nomenclature)
        );

        this.groupedByActuator.push({
          id: actuator.id,
          name: actuator.sensor || actuator.nomenclature,
          type: this.getActuatorTypeName(actuator.idActuatorType),
          state: actuator.state,
          value: actuator.value,
          image: actuator.imgActuator || actuator.pin,
          sensorValues: actuator.sensorValues || [],
          sensors: associatedSensors
        });
      });

      // Generar gráficos después de agrupar
      setTimeout(() => {
        this.generateActuatorSummaryCharts();
      }, 100);
    }

    groupBySensor() {
      this.groupedBySensor = [];
      
      // Obtener actuadores que tengan sensorValues (telares)
      const actuatorsWithSensorValues = this.dataStreaming.filter(item => 
        item.isActuator && item.sensorValues && item.sensorValues.length > 0
      );
      
      // Agrupar por tipo de actuador
      const actuatorTypes = {};
      actuatorsWithSensorValues.forEach(actuator => {
        const type = this.getActuatorTypeName(actuator.idActuatorType) || 'General';
        if (!actuatorTypes[type]) {
          actuatorTypes[type] = [];
        }
        actuatorTypes[type].push(actuator);
      });

      Object.keys(actuatorTypes).forEach(type => {
        this.groupedBySensor.push({
          type: type,
          sensors: actuatorTypes[type]
        });
      });

      // Generar gráficos comparativos
      setTimeout(() => {
        this.generateSensorComparisonCharts();
      }, 100);
    }

    groupByType() {
      this.groupedByType = [];
      
      // Agrupar por tipo de dispositivo (actuador o sensor)
      const types = {
        'Actuadores': this.dataStreaming.filter(item => item.isActuator),
        'Sensores': this.dataStreaming.filter(item => !item.isActuator)
      };

      Object.keys(types).forEach(typeName => {
        this.groupedByType.push({
          name: typeName,
          items: types[typeName]
        });
      });

      // Generar gráficos de distribución
      setTimeout(() => {
        this.generateTypeDistributionCharts();
      }, 100);
    }

    getActuatorTypeName(typeId: number): string {
      switch(typeId) {
        case 1: return 'Tanque';
        case 2: return 'Válvula';
        case 3: return 'Poza';
        case 5: return 'Telar';
        default: return 'Desconocido';
      }
    }

    generateActuatorSummaryCharts() {
      this.groupedByActuator.forEach(actuator => {
        if (actuator.sensors && actuator.sensors.length > 0) {
          this.createSummaryChart(actuator);
        }
      });
    }

    generateSensorComparisonCharts() {
      this.groupedBySensor.forEach(sensorGroup => {
        this.createComparisonChart(sensorGroup);
      });
    }

    generateTypeDistributionCharts() {
      this.groupedByType.forEach(typeGroup => {
        this.createDistributionChart(typeGroup);
      });
      
      // Generar los nuevos gráficos específicos para telares
      setTimeout(() => {
        this.generateTelarCharts();
      }, 200);
    }

    // Nuevos métodos para gráficos específicos de telares
    generateTelarCharts() {
      // Recalcular resumen de vibración
      this.vibrationSummary = null;
      this.createTelarStatusChart();
      this.createTelarPerformanceChart();
      this.createTimeEfficiencyChart();
      this.createOEEChart();
      this.createVibrationAnalysisChart();
      this.createValueDistributionChart();
      this.createProductionTrendChart();
    }

    createTelarStatusChart() {
      const canvas = document.getElementById('telarStatusChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Contar telares conectados vs desconectados (usando datos filtrados)
      const filteredActuators = this.getFilteredActuatorsAlternative();
      console.log('createTelarStatusChart - filteredActuators:', filteredActuators.length, filteredActuators.map(a => a.name));
      const connected = filteredActuators.filter(t => t.state === 1).length;
      const disconnected = filteredActuators.filter(t => t.state !== 1).length;

      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Conectados', 'Desconectados'],
          datasets: [{
            data: [connected, disconnected],
            backgroundColor: ['#4CAF50', '#F44336'],
            borderWidth: 3,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                font: { size: 12 },
                padding: 15
              }
            },
            title: {
              display: false
            }
          }
        }
      });
    }

    createTelarPerformanceChart() {
      const canvas = document.getElementById('telarPerformanceChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Preparar datos de vueltas por telar
      const labels = [];
      const vueltasData = [];
      const colors = [];

      this.groupedByActuator.forEach((telar, index) => {
        labels.push(telar.name || `Telar ${index + 1}`);
        
        let vueltas = 0;
        if (telar.sensorValues) {
          const vueltasValue = telar.sensorValues.find(sv => 
            (sv.name && sv.name.toLowerCase().includes('vuelta')) || 
            (sv.nomenclature && sv.nomenclature.toLowerCase().includes('vuelta'))
          );
          vueltas = vueltasValue ? parseFloat(vueltasValue.value) || 0 : 0;
        }
        vueltasData.push(vueltas);
        
        // Color basado en el estado
        colors.push(telar.state === 1 ? '#4CAF50' : '#F44336');
      });

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: 'Vueltas',
            data: vueltasData,
            backgroundColor: colors,
            borderColor: colors.map(c => this.adjustBrightness(c, -20)),
            borderWidth: 2,
            borderRadius: 5
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Vueltas',
                font: { size: 14, weight: 'bold' }
              },
              ticks: {
                font: { size: 12 }
              }
            },
            x: {
              title: {
                display: true,
                text: 'Telares',
                font: { size: 14, weight: 'bold' }
              },
              ticks: {
                font: { size: 11 },
                maxRotation: 45
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
    }

    createTimeEfficiencyChart() {
      const canvas = document.getElementById('timeEfficiencyChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Calcular tiempo activo vs pausa (usando datos filtrados)
      let tiempoActivo = 0;
      let tiempoPausa = 0;

      const filteredActuators = this.getFilteredActuatorsAlternative();
      filteredActuators.forEach(telar => {
        if (telar.sensorValues) {
          telar.sensorValues.forEach(sv => {
            if ((sv.name && sv.name.toLowerCase().includes('run_time')) || (sv.nomenclature && sv.nomenclature.toLowerCase().includes('run_time'))) {
              tiempoActivo += parseFloat(sv.value) || 0;
            } else if ((sv.name && sv.name.toLowerCase().includes('pause_time')) || (sv.nomenclature && sv.nomenclature.toLowerCase().includes('pause_time'))) {
              tiempoPausa += parseFloat(sv.value) || 0;
            }
          });
        }
      });

      // Función para formatear tiempo en formato HHh MMm SSs
      const formatTime = (seconds: number): string => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        
        const padZero = (num: number): string => {
          return num < 10 ? '0' + num : num.toString();
        };
        
        return `${padZero(hours)}h ${padZero(minutes)}m ${padZero(secs)}s`;
      };

      new Chart(ctx, {
        type: 'pie',
        data: {
          labels: [
            `Tiempo Activo\n${formatTime(tiempoActivo)}`,
            `Tiempo Pausa\n${formatTime(tiempoPausa)}`
          ],
          datasets: [{
            data: [tiempoActivo, tiempoPausa],
            backgroundColor: ['#4CAF50', '#FF5722'],
            borderWidth: 3,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                font: { size: 10 },
                padding: 8,
                usePointStyle: true
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                  return `${context.label}\n${formatTime(value)} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    }

    createOEEChart() {
      const canvas = document.getElementById('oeeChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Obtener datos OEE por telar
      const oeeDataPerTelar = this.getOEEPerTelar();
      
      if (!oeeDataPerTelar || oeeDataPerTelar.length === 0) {
        new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Sin datos'],
            datasets: [{
              label: 'OEE',
              data: [0],
              backgroundColor: '#e0e0e0',
              borderColor: '#bdbdbd',
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                  callback: function(value) {
                    return value + '%';
                  }
                }
              }
            }
          }
        });
        return;
      }

      // Preparar datos para el gráfico por telar
      const labels = oeeDataPerTelar.map(telar => telar.name);
      const availabilityData = oeeDataPerTelar.map(telar => telar.availability);
      const performanceData = oeeDataPerTelar.map(telar => telar.performance);
      const qualityData = oeeDataPerTelar.map(telar => telar.quality);
      const totalData = oeeDataPerTelar.map(telar => telar.total);

      // Crear gráfico de barras OEE por telar
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Disponibilidad',
              data: availabilityData,
              backgroundColor: availabilityData.map(val => 
                val >= 90 ? '#4CAF50' : val >= 80 ? '#8BC34A' : val >= 70 ? '#FFC107' : '#F44336'
              ),
              borderColor: availabilityData.map(val => 
                val >= 90 ? '#2E7D32' : val >= 80 ? '#558B2F' : val >= 70 ? '#F57C00' : '#C62828'
              ),
              borderWidth: 1
            },
            {
              label: 'Rendimiento',
              data: performanceData,
              backgroundColor: performanceData.map(val => 
                val >= 90 ? '#4CAF50' : val >= 80 ? '#8BC34A' : val >= 70 ? '#FFC107' : '#F44336'
              ),
              borderColor: performanceData.map(val => 
                val >= 90 ? '#2E7D32' : val >= 80 ? '#558B2F' : val >= 70 ? '#F57C00' : '#C62828'
              ),
              borderWidth: 1
            },
            {
              label: 'Calidad',
              data: qualityData,
              backgroundColor: qualityData.map(val => 
                val >= 90 ? '#4CAF50' : val >= 80 ? '#8BC34A' : val >= 70 ? '#FFC107' : '#F44336'
              ),
              borderColor: qualityData.map(val => 
                val >= 90 ? '#2E7D32' : val >= 80 ? '#558B2F' : val >= 70 ? '#F57C00' : '#C62828'
              ),
              borderWidth: 1
            },
            {
              label: 'OEE Total',
              data: totalData,
              backgroundColor: totalData.map(val => 
                val >= 90 ? '#2196F3' : val >= 80 ? '#03A9F4' : val >= 70 ? '#FF9800' : '#F44336'
              ),
              borderColor: totalData.map(val => 
                val >= 90 ? '#1565C0' : val >= 80 ? '#0277BD' : val >= 70 ? '#E65100' : '#C62828'
              ),
              borderWidth: 2
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                usePointStyle: true,
                padding: 15
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return context.dataset.label + ': ' + context.parsed.y.toFixed(1) + '%';
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback: function(value) {
                  return value + '%';
                }
              },
              grid: {
                color: '#e0e0e0'
              }
            },
            x: {
              grid: {
                display: false
              },
              ticks: {
                maxRotation: 45,
                minRotation: 0
              }
            }
          }
        }
      });
    }

    createVibrationAnalysisChart() {
      const canvas = document.getElementById('vibrationAnalysisChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Calcular resumen de vibración
      this.calculateVibrationSummary();
      const summary = this.getVibrationSummary();

      if (!summary) {
        new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Sin datos'],
            datasets: [{
              label: 'Sin datos de vibración',
              data: [0],
              backgroundColor: '#E0E0E0',
              borderColor: '#BDBDBD',
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              title: {
                display: true,
                text: 'No hay datos de vibración disponibles'
              }
            }
          }
        });
        return;
      }

      // Crear gráfico de barras con los 6 valores principales
      const labels = ['Acc X', 'Acc Y', 'Acc Z', 'Vel X', 'Vel Y', 'Vel Z'];
      const values = [summary.accX, summary.accY, summary.accZ, summary.velX, summary.velY, summary.velZ];
      
      // Colores basados en el estado de severidad
      const statusColors = {
        green: ['#4CAF50', '#66BB6A', '#81C784', '#A5D6A7', '#C8E6C9', '#E8F5E8'],
        yellow: ['#FFC107', '#FFCA28', '#FFD54F', '#FFE082', '#FFECB3', '#FFF8E1'],
        orange: ['#FF9800', '#FFA726', '#FFB74D', '#FFCC80', '#FFE0B2', '#FFF3E0'],
        red: ['#F44336', '#EF5350', '#E57373', '#EF9A9A', '#FFCDD2', '#FFEBEE']
      };

      const colors = statusColors[summary.status] || statusColors.green;

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: `${summary.telar} - Valores de Vibración`,
            data: values,
            backgroundColor: colors,
            borderColor: colors.map(c => this.adjustBrightness(c, -20)),
            borderWidth: 2,
            borderRadius: 5
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Valor (g / mm/s)',
                font: { size: 12, weight: 'bold' }
              },
              ticks: {
                font: { size: 10 }
              }
            },
            x: {
              title: {
                display: true,
                text: 'Ejes de Medición',
                font: { size: 12, weight: 'bold' }
              },
              ticks: {
                font: { size: 10 }
              }
            }
          },
          plugins: {
            legend: {
              display: false
            },
            title: {
              display: true,
              text: `Análisis de Vibración - ${summary.telar}`,
              font: { size: 14, weight: 'bold' }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed.y;
                  const unit = context.dataIndex < 3 ? 'g' : 'mm/s';
                  return `${label}: ${value.toFixed(3)} ${unit}`;
                }
              }
            }
          }
        }
      });
    }

    createValueDistributionChart() {
      const canvas = document.getElementById('valueDistributionChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!canvas) return;

      // Crear rangos de distribución de vueltas
      const vueltasValues = [];
      this.groupedByActuator.forEach(telar => {
        if (telar.sensorValues) {
          const vueltas = telar.sensorValues.find(sv => 
            (sv.name && sv.name.toLowerCase().includes('vuelta')) || 
            (sv.nomenclature && sv.nomenclature.toLowerCase().includes('vuelta'))
          );
          if (vueltas && vueltas.value) {
            vueltasValues.push(parseFloat(vueltas.value));
          }
        }
      });

      // Crear rangos
      const max = Math.max(...vueltasValues);
      const min = Math.min(...vueltasValues);
      const range = max - min;
      const step = range / 5;

      const ranges = [];
      const counts = [];

      for (let i = 0; i < 5; i++) {
        const start = min + (i * step);
        const end = min + ((i + 1) * step);
        ranges.push(`${Math.round(start)}-${Math.round(end)}`);
        
        const count = vueltasValues.filter(v => v >= start && v < end).length;
        counts.push(count);
      }

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ranges,
          datasets: [{
            label: 'Cantidad de Telares',
            data: counts,
            backgroundColor: '#9C27B0',
            borderColor: '#7B1FA2',
            borderWidth: 2,
            borderRadius: 5
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Cantidad',
                font: { size: 12, weight: 'bold' }
              }
            },
            x: {
              title: {
                display: true,
                text: 'Rango de Vueltas',
                font: { size: 12, weight: 'bold' }
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
    }

    createProductionTrendChart() {
      const canvas = document.getElementById('productionTrendChart') as HTMLCanvasElement;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Simular datos de tendencia (en un caso real vendrían de la API)
      const labels = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      const vueltasTrend = [45000, 52000, 48000, 55000, 51000, 38000, 42000];
      const tiempoTrend = [18, 20, 19, 22, 21, 16, 17];

      new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Vueltas (miles)',
              data: vueltasTrend.map(v => v / 1000),
              borderColor: '#FF5722',
              backgroundColor: 'rgba(255, 87, 34, 0.1)',
              borderWidth: 3,
              fill: true,
              tension: 0.4
            },
            {
              label: 'Tiempo Activo (hrs)',
              data: tiempoTrend,
              borderColor: '#3F51B5',
              backgroundColor: 'rgba(63, 81, 181, 0.1)',
              borderWidth: 3,
              fill: true,
              tension: 0.4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Valores',
                font: { size: 12, weight: 'bold' }
              }
            },
            x: {
              title: {
                display: true,
                text: 'Días de la Semana',
                font: { size: 12, weight: 'bold' }
              }
            }
          },
          plugins: {
            legend: {
              position: 'top',
              labels: {
                font: { size: 11 },
                padding: 15
              }
            }
          }
        }
      });
    }

    // Método auxiliar para ajustar brillo de colores
    adjustBrightness(hex: string, percent: number): string {
      const num = parseInt(hex.replace("#", ""), 16);
      const amt = Math.round(2.55 * percent);
      const R = (num >> 16) + amt;
      const G = (num >> 8 & 0x00FF) + amt;
      const B = (num & 0x0000FF) + amt;
      return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
        (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
        (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    }

    createSummaryChart(actuator: any) {
      const canvasId = 'summaryChart' + actuator.id;
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
      
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Crear datos para el gráfico resumen
      const labels = actuator.sensors.map(s => s.sensor || s.nomenclature);
      const values = actuator.sensors.map(s => parseFloat(s.value) || 0);
      const colors = actuator.sensors.map((_, i) => 
        `hsl(${(i * 360) / actuator.sensors.length}, 70%, 60%)`
      );

      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            data: values,
            backgroundColor: colors,
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                font: { size: 10 }
              }
            },
            title: {
              display: true,
              text: 'Distribución de Sensores'
            }
          }
        }
      });
    }

    createComparisonChart(sensorGroup: any) {
      const canvasId = 'comparisonChart' + sensorGroup.type.replace(/\s+/g, '');
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
      
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Crear datos para el gráfico comparativo
      const labels = sensorGroup.sensors.map(s => s.sensor || s.nomenclature);
      const values = sensorGroup.sensors.map(s => parseFloat(s.value) || 0);

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: sensorGroup.type,
            data: values,
            backgroundColor: this.color1,
            borderColor: this.color2,
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Valor'
              }
            }
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
    }

    createDistributionChart(typeGroup: any) {
      const canvasId = 'distributionChart' + typeGroup.name.replace(/\s+/g, '');
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
      
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Crear datos para el gráfico de distribución
      const connected = typeGroup.items.filter(item => item.state === 1).length;
      const disconnected = typeGroup.items.filter(item => item.state !== 1).length;

      new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Conectado', 'Desconectado'],
          datasets: [{
            data: [connected, disconnected],
            backgroundColor: ['#4CAF50', '#F44336'],
            borderWidth: 2,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                font: { size: 10 }
              }
            },
            title: {
              display: true,
              text: 'Estado de ' + typeGroup.name
            }
          }
        }
      });
    }

    // Método para generar IDs seguros para los canvas
    getSafeId(text: string): string {
      if (!text) return '';
      return text.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
    }

    // Métodos para métricas de producción
    getTotalVueltas(): string {
      let total = 0;
      this.getFilteredActuatorsAlternative().forEach(actuator => {
        if (actuator.sensorValues) {
          const vueltas = actuator.sensorValues.find(sv => 
            (sv.name && sv.name.toLowerCase().includes('vuelta')) || 
            (sv.nomenclature && sv.nomenclature.toLowerCase().includes('vuelta'))
          );
          if (vueltas && vueltas.value) {
            total += parseFloat(vueltas.value) || 0;
          }
        }
      });
      return total.toLocaleString() + ' giros';
    }

    getTotalTiempoActivo(): string {
      let total = 0;
      this.getFilteredActuatorsAlternative().forEach(actuator => {
        if (actuator.sensorValues) {
          const tiempo = actuator.sensorValues.find(sv => 
            (sv.nomenclature && sv.nomenclature.toLowerCase().includes('run_time')) 
           // (sv.name && sv.name.toLowerCase().includes('encendido')) || 
           // (sv.nomenclature && sv.nomenclature.toLowerCase().includes('encendido'))
          );
          if (tiempo && tiempo.value) {
            total += parseFloat(tiempo.value) || 0;
          }
        }
      });
      const horas = Math.floor(total / 3600);
      const minutos = Math.floor((total % 3600) / 60);
      return `${horas}h ${minutos}m`;
    }

    getTotalDistancia(): string {
      let total = 0;
      this.getFilteredActuatorsAlternative().forEach(actuator => {
        if (actuator.sensorValues) {
          const distancia = actuator.sensorValues.find(sv => 
            (sv.nomenclature && sv.nomenclature.toLowerCase().includes('distance'))
          );
          if (distancia && distancia.value) {
            total += parseFloat(distancia.value) || 0;
          }
        }
      });
      return (total ).toFixed(2) + ' m.';
    }

    // Métodos para manejar registros de producción
    loadRegistrosProduccion() {
      // Datos de ejemplo - en producción esto vendría de una API
      this.registrosProduccion = [
        {
          id: 1,
          telar: 'Telar 001',
          fechaInicio: new Date('2024-01-15T08:00:00'),
          fechaFin: new Date('2024-01-15T16:00:00'),
          distancia: 1500.50,
          estado: 'completado'
        },
        {
          id: 2,
          telar: 'Telar 002',
          fechaInicio: new Date('2024-01-15T09:30:00'),
          fechaFin: new Date('2024-01-15T17:30:00'),
          distancia: 2200.75,
          estado: 'completado'
        },
        {
          id: 3,
          telar: 'Telar 001',
          fechaInicio: new Date('2024-01-16T08:00:00'),
          fechaFin: new Date('2024-01-16T12:00:00'),
          distancia: 800.25,
          estado: 'en_progreso'
        }
      ];
    }

    addNewRegistro() {
      if (this.newRegistro.telar && this.newRegistro.fechaInicio && this.newRegistro.fechaFin && this.newRegistro.distancia) {
        const nuevoRegistro = {
          id: this.registrosProduccion.length + 1,
          telar: this.newRegistro.telar,
          fechaInicio: new Date(this.newRegistro.fechaInicio),
          fechaFin: new Date(this.newRegistro.fechaFin),
          distancia: parseFloat(this.newRegistro.distancia),
          estado: 'completado'
        };

        this.registrosProduccion.unshift(nuevoRegistro);
        this.cancelAddRegistro();
        
        // Mostrar mensaje de éxito
        this.alertService.showMessage('Registro agregado exitosamente', '', MessageSeverity.success);
      }
    }

    cancelAddRegistro() {
      this.showAddRegistroForm = false;
      this.newRegistro = {
        telar: '',
        fechaInicio: '',
        fechaFin: '',
        distancia: null
      };
    }

    editRegistro(registro: any) {
      // Implementar edición de registro
      console.log('Editar registro:', registro);
      this.alertService.showMessage('Funcionalidad de edición en desarrollo', '', MessageSeverity.info);
    }

    deleteRegistro(registro: any) {
      if (confirm('¿Está seguro de que desea eliminar este registro?')) {
        const index = this.registrosProduccion.findIndex(r => r.id === registro.id);
        if (index > -1) {
          this.registrosProduccion.splice(index, 1);
          this.alertService.showMessage('Registro eliminado exitosamente', '', MessageSeverity.success);
        }
      }
    }

    refreshRegistros() {
      this.loadRegistrosProduccion();
      this.alertService.showMessage('Registros actualizados', '', MessageSeverity.info);
    }

    exportRegistros() {
      // Implementar exportación a Excel
      const data = this.registrosProduccion.map(registro => ({
        'ID': registro.id,
        'Telar': registro.telar,
        'Fecha Inicio': registro.fechaInicio.toLocaleDateString(),
        'Hora Inicio': registro.fechaInicio.toLocaleTimeString(),
        'Fecha Fin': registro.fechaFin.toLocaleDateString(),
        'Hora Fin': registro.fechaFin.toLocaleTimeString(),
        'Duración': this.getDuration(registro.fechaInicio, registro.fechaFin),
        'Distancia (m)': registro.distancia,
        'Estado': this.getRegistroStatusText(registro)
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Registros de Producción');
      XLSX.writeFile(wb, 'registros_produccion.xlsx');
    }

    getDuration(fechaInicio: Date, fechaFin: Date): string {
      const diffMs = fechaFin.getTime() - fechaInicio.getTime();
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      return `${diffHours}h ${diffMinutes}m`;
    }

    getRegistroStatus(registro: any): string {
      const now = new Date();
      if (registro.fechaFin > now) {
        return 'status-en-progreso';
      } else {
        return 'status-completado';
      }
    }

    getRegistroStatusText(registro: any): string {
      const now = new Date();
      if (registro.fechaFin > now) {
        return 'En Progreso';
      } else {
        return 'Completado';
      }
    }

    getTotalDistanciaRegistros(): number {
      return this.registrosProduccion.reduce((total, registro) => total + registro.distancia, 0);
    }

    getTotalTiempoRegistros(): string {
      let totalMinutes = 0;
      this.registrosProduccion.forEach(registro => {
        const diffMs = registro.fechaFin.getTime() - registro.fechaInicio.getTime();
        totalMinutes += Math.floor(diffMs / (1000 * 60));
      });
      
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}m`;
    }

    getTelaresActivos(): number {
      const telaresUnicos = new Set(this.registrosProduccion.map(registro => registro.telar));
      return telaresUnicos.size;
    }

    // Método para filtrar sensorValues visibles
    getVisibleSensorValues(sensorValues: any[]): any[] {
      if (!sensorValues || !Array.isArray(sensorValues)) {
        return [];
      }
      return sensorValues.filter(sv => sv.isVisible === '1' || sv.isVisible === 1);
    }

    // Método específico para obtener datos de vibración (incluye todos los datos de vibración)
    getVibrationSensorValues(sensorValues: any[]): any[] {
      if (!sensorValues || !Array.isArray(sensorValues)) {
        return [];
      }
      return sensorValues.filter(sv => {
        const name = (sv.name || '').toLowerCase();
        const nomenclature = (sv.nomenclature || '').toLowerCase();
        
        // Incluir todos los datos de vibración independientemente de isVisible
        return name.includes('acceleration_') || 
               name.includes('velocity_') ||
               nomenclature.includes('acceleration_') || 
               nomenclature.includes('velocity_') ||
               name.includes('vibración') ||
               nomenclature.includes('vibración');
      });
    }

    // Métodos para análisis de vibración profesional
    getVibrationSummary(): any {
      if (!this.vibrationSummary) {
        this.calculateVibrationSummary();
      }
      return this.vibrationSummary;
    }

    calculateVibrationSummary() {
      // Buscar datos de vibración del primer telar disponible (usando datos filtrados)
      const filteredActuators = this.getFilteredActuatorsAlternative();
      console.log('calculateVibrationSummary - filteredActuators:', filteredActuators.length, filteredActuators.map(a => a.name));
      const telarWithVibration = filteredActuators.find(telar => {
        if (telar.sensorValues) {
          const vibrationValues = this.getVibrationSensorValues(telar.sensorValues);
          return vibrationValues.length > 0;
        }
        return false;
      });

      if (!telarWithVibration) {
        this.vibrationSummary = null;
        return;
      }

      const vibrationValues = this.getVibrationSensorValues(telarWithVibration.sensorValues);
      
      // Extraer valores de aceleración y velocidad
      const accX = this.getVibrationValue(vibrationValues, 'acceleration_x');
      const accY = this.getVibrationValue(vibrationValues, 'acceleration_y');
      const accZ = this.getVibrationValue(vibrationValues, 'acceleration_z');
      const velX = this.getVibrationValue(vibrationValues, 'velocity_x');
      const velY = this.getVibrationValue(vibrationValues, 'velocity_y');
      const velZ = this.getVibrationValue(vibrationValues, 'velocity_z');

      // Calcular RMS (Root Mean Square)
      const accRms = Math.sqrt(accX * accX + accY * accY + accZ * accZ);
      const velRms = Math.sqrt(velX * velX + velY * velY + velZ * velZ);

      // Determinar eje dominante
      const velValues = [velX, velY, velZ];
      const maxVelIndex = velValues.indexOf(Math.max(...velValues));
      const dominantAxis = ['X', 'Y', 'Z'][maxVelIndex];
      const dominantPercentage = (velValues[maxVelIndex] / velRms) * 100;

      this.vibrationSummary = {
        telar: telarWithVibration.name,
        accX, accY, accZ,
        velX, velY, velZ,
        accRms,
        velRms,
        dominantAxis,
        dominantPercentage,
        status: this.getVibrationStatus(velRms)
      };
    }

    getVibrationValue(vibrationValues: any[], type: string): number {
      const value = vibrationValues.find(sv => {
        const name = (sv.name || '').toLowerCase();
        const nomenclature = (sv.nomenclature || '').toLowerCase();
        return name.includes(type) || nomenclature.includes(type);
      });
      return value ? parseFloat(value.value) || 0 : 0;
    }

    getVibrationStatus(velRms: number): string {
      if (velRms < 1.8) return 'green';
      if (velRms < 4.5) return 'yellow';
      if (velRms < 7.1) return 'orange';
      return 'red';
    }


    getVibrationRecommendation(): string {
      const summary = this.getVibrationSummary();
      if (!summary) return '';

      const recommendations = {
        green: 'Mantener monitoreo. Sistema funcionando dentro de parámetros normales.',
        yellow: 'Establecer línea base y activar alerta si sube >30% en 7-14 días.',
        orange: 'Revisar alineación, fijaciones y apoyos. Programar inspección.',
        red: 'Acción inmediata requerida. Detener operación y realizar diagnóstico completo.'
      };

      const axisRecommendations = {
        X: 'Revisar rigidez en dirección horizontal y fijaciones laterales.',
        Y: 'Verificar apoyos verticales y componentes que exciten este eje.',
        Z: 'Chequear alineación axial y componentes en dirección longitudinal.'
      };

      const baseRecommendation = recommendations[summary.status] || '';
      const axisRecommendation = axisRecommendations[summary.dominantAxis] || '';

      return `${baseRecommendation} ${axisRecommendation}`.trim();
    }

    // Métodos para aplicar filtros
    getFilteredActuators(): any[] {
      if (this.selectedPanelIOT === 0) {
        return this.groupedByActuator;
      }
      
      console.log('=== FILTERING ACTUATORS ===');
      console.log('selectedPanelIOT:', this.selectedPanelIOT);
      console.log('paneliotSearch:', this.paneliotSearch);
      
      // Buscar el sensor seleccionado en paneliotSearch usando múltiples criterios
      const selectedSensor = this.paneliotSearch.find(sensor => 
        sensor.idSensor === this.selectedPanelIOT || 
        sensor.id === this.selectedPanelIOT ||
        sensor.sensorId === this.selectedPanelIOT
      );
      
      console.log('Selected sensor from paneliotSearch:', selectedSensor);
      
      if (!selectedSensor) {
        console.log('No sensor found in paneliotSearch, trying dataStreaming...');
        
        // Buscar directamente en dataStreaming
        const sensorInDataStreaming = this.dataStreaming.find(item => 
          !item.isActuator && (
            item.id === this.selectedPanelIOT ||
            item.idSensor === this.selectedPanelIOT ||
            item.sensorId === this.selectedPanelIOT
          )
        );
        
        console.log('Sensor in dataStreaming:', sensorInDataStreaming);
        
        if (!sensorInDataStreaming) {
          console.log('No sensor found anywhere');
          return this.groupedByActuator;
        }
        
        // Usar el sensor encontrado en dataStreaming
        const sensorName = sensorInDataStreaming.sensor || sensorInDataStreaming.nomenclature;
        console.log('Using sensor name:', sensorName);
        
        // Buscar actuadores que contengan este sensor
        const actuatorsWithThisSensor = this.dataStreaming.filter(item => {
          if (item.isActuator && item.sensors) {
            const hasSensor = item.sensors.includes(sensorName);
            console.log('Actuator', item.sensor || item.nomenclature, 'has sensor', sensorName, ':', hasSensor);
            return hasSensor;
          }
          return false;
        });
        
        console.log('Actuators with this sensor:', actuatorsWithThisSensor);
        
        // Filtrar groupedByActuator
        const filteredActuators = this.groupedByActuator.filter(actuator => {
          const hasMatchingActuator = actuatorsWithThisSensor.some(actuatorData => 
            actuatorData.sensor === actuator.name || 
            actuatorData.nomenclature === actuator.name
          );
          console.log('Grouped actuator', actuator.name, 'matches:', hasMatchingActuator);
          return hasMatchingActuator;
        });
        
        console.log('Final filtered actuators:', filteredActuators);
        return filteredActuators;
      }
      
      // Usar el sensor encontrado en paneliotSearch
      const sensorName = selectedSensor.sensor || selectedSensor.nomenclature;
      console.log('Using sensor name from paneliotSearch:', sensorName);
      
      // Buscar actuadores que contengan este sensor
      const actuatorsWithThisSensor = this.dataStreaming.filter(item => {
        if (item.isActuator && item.sensors) {
          const hasSensor = item.sensors.includes(sensorName);
          console.log('Actuator', item.sensor || item.nomenclature, 'has sensor', sensorName, ':', hasSensor);
          return hasSensor;
        }
        return false;
      });
      
      console.log('Actuators with this sensor:', actuatorsWithThisSensor);
      
      // Filtrar groupedByActuator
      const filteredActuators = this.groupedByActuator.filter(actuator => {
        const hasMatchingActuator = actuatorsWithThisSensor.some(actuatorData => 
          actuatorData.sensor === actuator.name || 
          actuatorData.nomenclature === actuator.name
        );
        console.log('Grouped actuator', actuator.name, 'matches:', hasMatchingActuator);
        return hasMatchingActuator;
      });
      
      console.log('Final filtered actuators:', filteredActuators);
      return filteredActuators;
    }

    getFilteredRegistros(): any[] {
      if (this.selectedPanelIOT === 0) {
        return this.registrosProduccion;
      }
      
      console.log('=== FILTERING REGISTROS ===');
      console.log('selectedPanelIOT:', this.selectedPanelIOT);
      
      // Buscar el sensor seleccionado usando múltiples criterios
      const selectedSensor = this.paneliotSearch.find(sensor => 
        sensor.idSensor === this.selectedPanelIOT || 
        sensor.id === this.selectedPanelIOT ||
        sensor.sensorId === this.selectedPanelIOT
      );
      
      console.log('Selected sensor for registros:', selectedSensor);
      
      let sensorName = null;
      
      if (selectedSensor) {
        sensorName = selectedSensor.sensor || selectedSensor.nomenclature;
      } else {
        // Buscar directamente en dataStreaming
        const sensorInDataStreaming = this.dataStreaming.find(item => 
          !item.isActuator && (
            item.id === this.selectedPanelIOT ||
            item.idSensor === this.selectedPanelIOT ||
            item.sensorId === this.selectedPanelIOT
          )
        );
        
        if (sensorInDataStreaming) {
          sensorName = sensorInDataStreaming.sensor || sensorInDataStreaming.nomenclature;
        }
      }
      
      if (!sensorName) {
        console.log('No sensor name found for registros filter');
        return this.registrosProduccion;
      }
      
      console.log('Using sensor name for registros:', sensorName);
      
      // Buscar el actuador que contiene este sensor
      const actuatorData = this.dataStreaming.find(item => 
        item.isActuator && item.sensors && item.sensors.includes(sensorName)
      );
      
      if (actuatorData) {
        const actuatorName = actuatorData.sensor || actuatorData.nomenclature;
        const filtered = this.registrosProduccion.filter(registro => 
          registro.telar === actuatorName
        );
        console.log('Filtered registros for', actuatorName, ':', filtered);
        return filtered;
      }
      
      console.log('No actuator found for registros filter');
      return [];
    }

    debugFilterData() {
      console.log('=== DEBUG FILTER DATA ===');
      console.log('selectedPanelIOT:', this.selectedPanelIOT);
      console.log('paneliotSearch:', this.paneliotSearch);
      console.log('dataStreaming length:', this.dataStreaming.length);
      console.log('groupedByActuator length:', this.groupedByActuator.length);
      console.log('registrosProduccion length:', this.registrosProduccion.length);
      
      // Mostrar estructura de algunos elementos
      if (this.dataStreaming.length > 0) {
        console.log('Sample dataStreaming item:', this.dataStreaming[0]);
      }
      if (this.groupedByActuator.length > 0) {
        console.log('Sample groupedByActuator item:', this.groupedByActuator[0]);
      }
      if (this.paneliotSearch.length > 0) {
        console.log('Sample paneliotSearch item:', this.paneliotSearch[0]);
      }
      
      // Mostrar todos los sensores disponibles
      console.log('All sensors in paneliotSearch:');
      this.paneliotSearch.forEach((sensor, index) => {
        console.log(`${index}:`, {
          id: sensor.id,
          idSensor: sensor.idSensor,
          sensorId: sensor.sensorId,
          sensor: sensor.sensor,
          nomenclature: sensor.nomenclature
        });
      });
      
      // Mostrar todos los actuadores
      console.log('All actuators in dataStreaming:');
      this.dataStreaming.filter(item => item.isActuator).forEach((actuator, index) => {
        console.log(`${index}:`, {
          id: actuator.id,
          sensor: actuator.sensor,
          nomenclature: actuator.nomenclature,
          sensors: actuator.sensors
        });
      });
      
      console.log('========================');
    }

    // Método unificado para obtener actuadores filtrados (considera actuador/sensor y turno)
    getFilteredActuatorsForViews(): any[] {
      let filteredActuators = this.groupedByActuator;
      
      // Aplicar filtro de actuador/sensor si está seleccionado
      if (this.selectedPanelIOT !== 0) {
        filteredActuators = this.getFilteredActuatorsAlternative();
      }
      
      // Aplicar filtro de turno si está seleccionado (solo para empresa 20)
      if (this.enterpriseSelect === 20 && this.shiftSelect !== 0) {
        filteredActuators = this.applyShiftFilter(filteredActuators);
      }
      
      return filteredActuators;
    }

    // Método para aplicar filtro de turno a los actuadores
    applyShiftFilter(actuators: any[]): any[] {
      if (this.shiftSelect === 0) {
        return actuators; // Todos los turnos
      }
      
      // Filtrar por turno específico
      return actuators.filter(actuator => {
        // Aquí puedes agregar lógica específica para filtrar por turno
        // Por ejemplo, si los actuadores tienen información de turno
        // Por ahora, retornamos todos ya que el filtro de turno se aplica a nivel de datos
        return true;
      });
    }

    // Método alternativo de filtrado más directo
    getFilteredActuatorsAlternative(): any[] {
      console.log('=== getFilteredActuatorsAlternative ===');
      console.log('selectedPanelIOT:', this.selectedPanelIOT);
      console.log('groupedByActuator length:', this.groupedByActuator.length);
      
      if (this.selectedPanelIOT === 0) {
        console.log('Retornando todos los actuadores:', this.groupedByActuator.length);
        return this.groupedByActuator;
      }
      
      console.log('=== ALTERNATIVE FILTERING ===');
      console.log('selectedPanelIOT:', this.selectedPanelIOT);
      
      // Crear un mapa de sensores a actuadores
      const sensorToActuatorMap = new Map();
      
      this.dataStreaming.forEach(item => {
        if (item.isActuator && item.sensors) {
          item.sensors.forEach(sensorName => {
            sensorToActuatorMap.set(sensorName, item);
          });
        }
      });
      
      console.log('Sensor to Actuator Map:', sensorToActuatorMap);
      
      // Buscar el sensor seleccionado
      let selectedSensorName = null;
      
      // Primero en paneliotSearch
      const selectedSensor = this.paneliotSearch.find(sensor => 
        sensor.idSensor === this.selectedPanelIOT || 
        sensor.id === this.selectedPanelIOT ||
        sensor.nomenclature === this.selectedPanelIOT || 
        sensor.sensorId === this.selectedPanelIOT
      );
      
      if (selectedSensor) {
        selectedSensorName = selectedSensor.sensor || selectedSensor.nomenclature;
      } else {
        // Luego en dataStreaming
        const sensorInDataStreaming = this.dataStreaming.find(item => 
          !item.isActuator && (
            item.id === this.selectedPanelIOT ||
            item.idSensor === this.selectedPanelIOT ||
            item.sensorId === this.selectedPanelIOT
          )
        );
        
        if (sensorInDataStreaming) {
          selectedSensorName = sensorInDataStreaming.sensor || sensorInDataStreaming.nomenclature;
        }
      }
      
      console.log('Selected sensor name:', selectedSensorName);
      
      if (!selectedSensorName) {
        console.log('No sensor name found');
        return this.groupedByActuator;
      }
      /*
      // Buscar el actuador que contiene este sensor
      const actuatorData = sensorToActuatorMap.get(selectedSensorName);
      console.log('Found actuator data:', actuatorData);
      
      if (!actuatorData) {
        console.log('No actuator found for sensor:', selectedSensorName);
        return this.groupedByActuator;
      }*/
      
      // Filtrar groupedByActuator
      console.log("this.groupedByActuator",this.groupedByActuator);
   //   const actuatorName = actuatorData.sensor || actuatorData.nomenclature;
      const filtered = this.groupedByActuator.filter(actuator => 
        actuator.id === this.selectedPanelIOT
      );
      
      //console.log('Actuator name to filter:', actuatorName);
      console.log('Available actuator names:', this.groupedByActuator.map(a => a.name));
     // console.log('Alternative filtered result:', filtered.length, 'actuators');
      return filtered;
    }

    // Métodos auxiliares para el indicador de filtros
    getSelectedSensorName(): string {
      if (this.selectedPanelIOT === 0) return '';
      
      const selectedSensor = this.paneliotSearch.find(sensor => 
        sensor.nomenclature === this.selectedPanelIOT
      );
      
      return selectedSensor ? selectedSensor.sensor : 'Sensor seleccionado';
    }

  getShiftName(shiftId: number): string {
    switch (shiftId) {
      case 0: return 'Todos';
      case 1: return 'Día';
      case 2: return 'Noche';
      default: return 'Desconocido';
    }
  }

  // Método para alternar entre vista original y dashboard
  toggleDashboardView() {
    if (this.currentDashboardView === 'original') {
      this.currentDashboardView = 'dashboard';
    } else {
      this.currentDashboardView = 'original';
    }
    console.log('Dashboard view toggled to:', this.currentDashboardView);
  }

  // Método para manejar el cambio de vista del dashboard
  onDashboardViewChange(view: string) {
    this.currentDashboardView = view;
    console.log('Dashboard view changed to:', view);
    
    // Cambiar la vista del panel IoT según el tab seleccionado
    switch(view) {
      case 'dashboard':
        // Mostrar el dashboard con widgets
        this.showTypeSelect = '3'; // Vista gráfica
        this.groupingType = 'actuator';
        break;
      case 'telares':
        // Mostrar vista de telares
        this.showTypeSelect = '3';
        this.groupingType = 'actuator';
        break;
      case 'graficos':
        // Mostrar vista de gráficos
        this.showTypeSelect = '3';
        this.groupingType = 'type';
        break;
      case 'registros':
        // Mostrar vista de registros
        this.showTypeSelect = '3';
        this.groupingType = 'registros';
        break;
    }
  }
}
